<template>
  <div class="variance-analysis-base pa-6 d-flex flex-column gap-6" data-testid="variance-analysis-base">
    <!-- Breadcrumbs for RU Data Section view -->
    <Breadcrumbs
      v-if="showCycleBreadcrumb"
      :glCodeText="breadcrumbCycleLabel"
      :glCodeInfo="cycleBreadcrumbText"
      :activeCommentary="{}"
      :getStatusLabel="getStatusLabel"
      :isRefreshing="isReportingUnitdataloading"
      :reportingType="reportingType || 'pl'"
      @back="handleBackFromRUData"
      @refresh="handleRefreshData"
      data-testid="variance-analysis-base__breadcrumbs"
      :showRefresh="true"
    />
    <CycleHeader
      v-if="!showCycleBreadcrumb"
      :cycletype="cycletype"
      :actualLabel="$nova.labelsName('cycle_page', 'variance_analysis_label', 'Actual Cycle')"
      :forecastLabel="$nova.labelsName('cycle_page', 'forecast_cycle_label', 'Forecast Cycle')"
      @refresh-data="handleRefreshData"
    />
    
    <div class="filter-wrapper">
      <cfilter ref="childfilter"
        :cycletype="cycletype"
        @newdata="listenfilter"
        @isDataSynced="manualFiltersync"
        @isReportingunitSelected="setReportingUnit"
        :is-loading="isRUListLoading || isReportingUnitdataloading"
        @manual-filter-refresh="manualFilterRefresh"
        :showrole="false"
        :showReset="false"
      />
    </div>

    <div class="d-flex flex-column ">
      <r-u-view-toolbar
        v-if="!showCycleBreadcrumb"
        :toggleview="toggleview"
        :selectedreportingunit="selectedreportingunit"
        :selectedperiod="selectedperiod"
        :selectedregionalapproval="selectedregionalapproval"
        :selectedlocalapproval="selectedlocalapproval"
        :isregionalapproverinru="isregionalapproverinru"
        :islocalapproverinru="islocalapproverinru"
        :reporting-units-for-mail-reminder="reportingUnitsForMailReminder"
        :selectednetwork="selectednetwork"
        :last-updated-at="lastUpdatedAt"
        :commentary-regional-key-label="commentary_regional_key_label"
        @navigate-view="navigateView"
        @approve-regional-ru="approveRegionalRU"
        @approve-local-ru="approveLocalRU"
        @send-reminder-email-multi="sendEmailReminderForSelectedCycles"
        @show-email-reminder="showEmailReminderConfirm"
        @sync-now="loadContent(false, true, 'manual')"
        @download-all-ru-cycle="getDownloadAllRUcyclelist"
        @download-all-ru="getDownloadAllRUlist"
        @refresh-data="handleRefreshData"
      />

      <div class="pa-5 title grey--text text-center" v-if="role.length === 0">
        <span class="dots-loader">Please wait as we load your data<span>.</span><span>.</span><span>.</span></span>
        <div>If you are unable to see your data on this screen then kindly contact admin to provide you with access
        </div>
      </div>
      <div v-else>
        <transition :name="viewTransitionName" mode="out-in">
        <div v-if="selectedyear === 'all'" key="year-select">
          <div class="title grey--text">{{ 'Select a Year'  }}</div>
          <div class="">
            <template v-for="(v, k) in year">
              <div :key="k" @click="selectedyear = Number(v._id)" v-if="v._id !== 'all'"
                class="d-inline-block px-4 py-2 hoverable border-left-grey border-on cursor-pointer mr-4 mt-2">
                {{ v._id }}
              </div>
            </template>
          </div>
        </div>
        <div v-else-if="selectedperiod === 'all'" key="period-list">
          <span v-if="perioddata.length > 0">Note: GL status wise summary is available if period is selected.</span>
          <RUList type="Period" :data="perioddata" @click="setPeriod" @getreportingunit="loadReportingUnit(false, false)"
            :view="toggleview" :loading='loading' @reset-filters="handleResetFilters"></RUList>

        </div>
        <div v-else-if="toggleview === 0 && !isReportingUnitClicked && selectedperiod !== 'all'" key="ru-list-toggle0">
          <RUList ref="ruList" type="Reporting Unit" :data="reportingunitdata" @click="setReportingUnit"
            :view="toggleview" :enablecheckboxlocal="islocalapproverinru"
            :enablecheckboxregional="isregionalapproverinru" :enableMailSenderCheckbox="isMailRemainderRequired"
            :isfiltereddata="isFilteredData" :isDataRefreshed="isDataRefreshed"
            :has-more="hasMoreReportingUnits"
            :total-count="reportingUnitsTotalCount"
            :current-page="reportingUnitsCurrentPage"
            :possible-roles="accessHierarchyPossibleRoles"
            @approvelocal="setapprovelocalids" @approveregional="setapproveregionalids" @multipleReminderMails="setReportingUnitsForMailReminder"
            @sendRemainderMail="sendEmailReminderForSelectedCycle" @getreportingunit="handleReportingUnitRequest" :cycletype="cycletype" :loading="isRUListLoading"
            @reset-filters="handleResetFilters">
          </RUList>
        </div>
        <!-- <div v-else-if="selectednetwork === 'all' && (toggleview === 2 || toggleview === 1)">
          <RUList type="Network" :data="networkdata" @click="setNetwork" :view="toggleview"
            :isfiltereddata=isFilteredData @getnetworkdata="loadNetwork" :loading="loading"
            @reset-filters="handleResetFilters">
          </RUList>
        </div> -->
        <!-- <div v-else-if="selectedregion === 'all' && toggleview !== 3 && toggleview !== 0">
          <RUList type="Region" :data="regiondata" @click="setRegion" :view="toggleview" :loading="loading"
            @reset-filters="handleResetFilters">
          </RUList>
        </div> -->
        <!-- <div v-else-if="selectedcountry === 'all' && toggleview !== 3 && toggleview !== 0">
          <RUList type="Country" :data="countrydata" @click="setCountry" :view="toggleview" :loading="loading"
            @reset-filters="handleResetFilters">
          </RUList>
        </div> -->
        <div
          v-else-if="selectedperiod !== 'all' && selectedperiod && (selectedreportingunit === 'all') && toggleview !== 3"
          key="ru-list-other">
          <RUList type="Reporting Unit" :data="reportingunitdata" @click="setReportingUnit" :view="toggleview"
            :enablecheckboxlocal="islocalapproverinru" :enablecheckboxregional="isregionalapproverinru"
            :enableMailSenderCheckbox="isMailRemainderRequired"
            :isDataRefreshed="isDataRefreshed" :isfiltereddata="isFilteredData"
            :has-more="hasMoreReportingUnits" :page-size="15"
            :total-count="reportingUnitsTotalCount"
            :current-page="reportingUnitsCurrentPage"
            :possible-roles="accessHierarchyPossibleRoles"
            @approvelocal="setapprovelocalids" @approveregional="setapproveregionalids"
            @multipleReminderMails="setReportingUnitsForMailReminder"
            @sendRemainderMail="sendEmailReminderForSelectedCycle"
            @getreportingunit="handleReportingUnitRequest" :cycletype="cycletype" :loading="isRUListLoading"
            @reset-filters="handleResetFilters">
          </RUList>
        </div>
        <div v-else-if="(selectedreportingunit !== 'all' && selectedreportingunit) || (toggleview === 0 && isReportingUnitClicked) || toggleview === 3" key="ru-data-section">
          <r-u-data-section
          :selectedreportingunit="selectedreportingunit"
          :isReportingUnitClicked="isReportingUnitClicked"
          :isReportingUnitdataloading="isReportingUnitdataloading"
          :commentarydata="commentarydata"
          :filteredcommentarydata="filteredcommentarydata"
          :pagedItems="pagedItems"
          :commentarycycledata="commentarycycledata"
          :commentarycycledatalist="commentarycycledatalist"
          :commentarysummarydata="commentarysummarydata"
          :toggleview="toggleview"
          :toggletableview="toggletableview"
          :isCommentaryView="isCommentaryView"
          :customfilterstoggle="customfilterstoggle"
          :selectedfilter="selectedfilter"
          :multiselectdata="multiselectdata"
          :workflows="workflows"
          :ispreparer="ispreparer"
          :isapprover="isapprover"
          :isregionalapprover="isregionalapprover"
          :ismanager="ismanager"
          :isviewonly="isviewonly"
          :ispendinglocalruapproval="ispendinglocalruapproval"
          :ispendingregionalruapproval="ispendingregionalruapproval"
          :isSodEnabled="isSodEnabled"
          :ruRoleOptions="ruRoleOptions"
          :selectedRuRole="selectedRuRole"
          :alluserassigned="alluserassigned"
          :commentary_local_key_label="commentary_local_key_label"
          :commentary_regional_key_label="commentary_regional_key_label"
          :local_controls_label="local_controls_label"
          :local_management_label="local_management_label"
          :regional_controls_label="regional_controls_label"
          :regional_management_label="regional_management_label"
          :actual_label="actual_label"
          :proforma_shortform_label="proforma_shortform_label"
          :forcast_shortform_label="forcast_shortform_label"
          :workflowsDisabledMessage="workflowsDisabledMessage"
          :cycletype="cycletype"
          :cycletypeReadview="cycletypeReadview"
          :cycletypeItem="cycletypeItem"
          :tablecolors="tablecolors"
          :expandedIds="expandedIds"
          :isAllExpanded="isAllExpanded"
          :page="page"
          :pagecount="pagecount"
          :pageSize="pageSize"
          :workflowtext="workflowtext"
          :allworkflowstext="allworkflowstext"
          :allworkflowskeys="allworkflowskeys"
          :isBulkApproveEnabled="isbulkapprovalcrosscontrolenabled || isbulkapprovalmanagementcontrolenabled"
          :activitylogconfigcycle="activitylogconfigcycle"
          :activitylogconfiggl="activitylogconfiggl"
          :clientbyclientdata_netsales="clientbyclientdata_netsales"
          :clientbyclientdata_revenue="clientbyclientdata_revenue"
          :cyclestage="cyclestage"
          :isFilterSet="isFilterSet"
          :periodName="periodlist[selectedperiod] ? periodlist[selectedperiod].name : ''"
          :yearName="String(selectedyear || '')"
          :reportingType="reportingType || 'pl'"
          :ungroupedGLItems="ungroupedItems"
          :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
          @update:cycletype-readview="cycletypeReadview = $event"
          @update:selected-filter="selectedfilter = $event"
          @update:custom-filters-toggle="customfilterstoggle = $event"
          @toggle-view="toggleViewFun"
          @select-all="select_all"
          @toggle-expand="toggleExpand"
          @toggle-expand-all="toggleExpandAll"
          @row-intersect="handleIntersect"
          @get-net-sales-data="getNetSalesData" 
          @get-revenue-data="getRevenueData"
          @open-user-list-dialog="userlistdialog = true"
          @open-custom-filters-dialog="customfiltersdialog = true"
          @open-submit-dialog="({ row, mode, approver }) => openSubmitDialog(row, mode, approver)"
          @perform-bulk-task="performBulkTask"
          @preview-bulk-commentary="previewBulkCommentary"
          @open-bulk-commentary-dialog-local="bulkcommentaryDialogueOpen"
          @open-bulk-commentary-dialog-approver="bulkcommentaryDialogueOpenisApprover"
          @open-bulk-approve-dialog="bulkapproveDialogueOpen"
          @get-previous-cycle-list="getPreviousCycleList"
          @download-excel="downloadExcel"
          @download-pdf="getpdfFun"
          @refresh-ru-data="loadData"
          @download-all-ru-cycle-list="getDownloadAllRUcyclelist"
          @download-all-ru-list="getDownloadAllRUlist"
          @reset-filters="handleResetFilters"
          @update:selectedRuRole="val => (selectedRuRole = val)"
          @update:page="val => (page = val)"
          @update:multiselectdata="val => (multiselectdata = val)"
          @open-workflows-dialog="workflowsdialog = true"
          @open-status-insights-dialog="statusinsightsdialog = true"
          @statement-type-change="handleStatementTypeChange"
        />
      </div>
      </transition>
      </div>
    </div>

    <email-reminder-dialog 
         v-if="confirmEmailReminderDialog"
         v-model="confirmEmailReminderDialog" 
         :loading="emailreminderdialogloading"
         :eligible-reporting-units="eligibleReportingUnitsForEmailReminder"
         @confirm="confirmSendEmailReminder" 
         @cancel="cancelEmailReminder"
    />

      <status-help-dialog v-if="statushelpdialog" v-model="statushelpdialog" />

      <lb-dialog v-if="bulksubmitdialog" v-model="bulksubmitdialog" heading="Bulk Upload Commentary"
        :width="(Object.keys(bulksubmitfiledata).length > 0) ? '' : '500'" :loading="bulksubmitloading">
        <template v-slot:body>
          <div class="mb-4">
            <v-btn color="primary" class="mb-3" @click="downloadExcel()"><span>Download Template</span></v-btn>
            
            <lb-file 
              v-model="bulksubmitfiledatafile" 
              :label="Object.keys(bulksubmitfiledata).length > 0 ? 'Re-Upload' : 'Browse Files'" 
              :drag="false" 
              hidedetails 
              @change="readBulkSubmit()"
              :displayname="true" 
              accept=".xlsx,.xls,.xlsm,.xlsb"
              :dropzone="true"
              dropzone-text="Drag and drop your Excel file here"
              dropzone-hint="Supported formats: .xlsx, .xls, .xlsm, .xlsb"
              :remove="true"
            />
          </div>
          <div v-if="Object.keys(bulksubmitfiledata).length > 0">
            <div v-if="bulksubmitfiledataerror" class="error--text font-weight-semibold">
              We found few errors. Please rectify the same to proceed with the upload
            </div>
            <lb-datatablenew :headers="bulkUploadCommentaryHeaders" :items="bulksubmitfiledataList"
              :enableslot="['message', 'ignore']" :loading="bulksubmitloading">
              <template v-slot:ignore="{ item }">
                <td style="width:30px;">
                  <v-icon v-if="(item.error || !item.__found)" color="error">mdi-close-circle</v-icon>
                  <v-icon v-else-if="!item.ignore" color="success">mdi-check-circle</v-icon>
                </td>
              </template>
              <template v-slot:message="{item}">
                <td :class="`${(bulksubmitfiledataerror || item.ignore)?'error--text':''}`">
                  <span v-if="!item.__found">{{$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code')}} not found</span>
                  <span v-else>{{item.error || item.message}}</span>
                </td>
              </template>
            </lb-datatablenew>
          </div>
         
        </template>
        <template v-slot:actions>
          <div v-if="bulksubmitfiledataerror" class="error--text font-weight-semibold">
            We found few errors. Please rectify the same to proceed with the upload
          </div>
          <div v-else-if="Object.keys(bulksubmitfiledata).length > 0" class="">
            Note: Only the GL's which are in {{
              $nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited','Local commentary awaited') }}
            will be updated with this bulk upload option.
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="Object.keys(bulksubmitfiledata).length > 0 && !bulksubmitfiledataerror"
            @click="bulkUploadCommentaryByGL()" color="" class="ml-2 primary"
            :disabled='(ispreparer && !workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf)'><span>Proceed to
            Upload</span></v-btn>
        </template>
      </lb-dialog>

      <bulk-upload-commentary-approver-dialog
        v-if="approverBulkSubmitPop"
        v-model="approverBulkSubmitPop"
        :loading="approverBulkSubmitLoading"
        :width="Object.keys(approverBulkSubmitData).length > 0 ? '' : '500'"
        :file-value="approverBulkSubmitDataFile"
        :headers="bulkUploadCommentaryisApproverHeaders"
        :items="approverBulkSubmitFileDataListis"
        :has-error="bulksubmitfiledataerrorisApprover"
        :disable-submit="isBulkSubmitDisabled"
        :gl-code-label="$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code')"
        :local-commentary-awaited-label="$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited','Local commentary awaited')"
        @download-template="downloadExcelisApprover"
        @file-change="readBulkSubmitisApprover"
        @update:file-value="val => (approverBulkSubmitDataFile = val)"
        @submit="bulkUploadCommentaryByGLisApprover"
      />

      <bulk-approve-local-dialog
        v-if="bulkapprovelocaldialog"
        v-model="bulkapprovelocaldialog"
        :loading="bulkapprovelocalloading"
        :width="Object.keys(bulkapprovelocalfiledata).length > 0 ? '' : '500'"
        :file-data-list="bulkApproveLocalItems"
        :has-error="bulkapprovelocalfiledataerror"
        :is-regional-commentary-automation-enabled="isRegionalCommentaryAutomationEnabled"
        :is-approver="isapprover"
        :is-regional-approver="isregionalapprover"
        :file-value="bulkapprovelocalfiledatafile"
        @download-template="downloadExcel"
        @file-change="readBulkApproveLocal"
        @update:file-value="val => (bulkapprovelocalfiledatafile = val)"
        @upload="bulkUploadApproveLocalCommentaryByGL"
      />
      <commentary-dialog
      v-if="commantorydialog"
      v-model="commantorydialog"
      :loading="commentaryloading"
      :bulksubmit="bulksubmit"
      :bulktype="bulktype"
      :bulkcommentall.sync="bulkcommentall"
      :bulkcommentreplace.sync="bulkcommentreplace"
      :selectedcommentary="selectedcommentary"
      :multiselectdata="multiselectdata"
      :tablecolors="tablecolors"
      :cycletype="cycletype"
      :cycletypeReadview="cycletypeReadview"
      :ispreparer="ispreparer"
      :isapprover="isapprover"
      :isregionalapprover="isregionalapprover"
      :rejectTargetList="rejectTargetList"
      :userid="userid"
      :sodEnabled="isSodEnabled"
      :workflowtext="workflowtext"
      :workflows="workflows"
      :cyclestage="cyclestage"
      :commentary_local_key_label="commentary_local_key_label"
      :commentary_regional_key_label="commentary_regional_key_label"
      :aggregatedLabelText="aggregatedLabelText"
      :localCommentaryGenAiBtntab="localCommentaryGenAiBtntab"
      :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
      :isLocalCommentaryCollapsed="isLocalCommentaryCollapsed"
      :isLocalCommentaryReasonCollapsed="isLocalCommentaryReasonCollapsed"
      :isGlMandatoryRequestFlag="isGlMandatoryRequestFlag"
      :replaceExistingCommentFlag="replaceExistingCommentFlag"
      :charttab.sync="charttab"
      :commentarySubmitDialogueViewMode="commentarySubmitDialogueViewMode"
      :toggleview="toggleview"
      :reportingType="reportingType || 'pl'"
      :actualLabel="actual_label"
      :proformaLabel="proforma_shortform_label"
      :forecastLabel="forcast_shortform_label"
      :trendYear="selectedyear"
      :trendPeriod="selectedperiod"
      :trendReportingUnit="selectedreportingunit"
      :lastActionsOnGL="lastActionsOnGL"
      :attachmentfile.sync="attachmentfile"
      :attachmentfileloading="attachmentfileloading"
      :attachmentfilepercentage="attachmentfilepercentage"
      :isTyping="isTyping"
      :loadingtext1="loadingtext1"
      :loadingtext2="loadingtext2"
      :isThresholdExceedLocalCommentary="isThresholdExceedLocalCommentary"
      :isThresholdExceedJVSummarisation="isThresholdExceedJVSummarisation"
      :showSummaryTab="showSummaryTab"
      :summaryAiProforma.sync="summaryAiProforma"
      :summaryAiForecast.sync="summaryAiForecast"
      :aitext.sync="aitext"
      :requestcommentarylocalcontrol.sync="requestcommentarylocalcontrol"
      :requestcommentarylocalmanagement.sync="requestcommentarylocalmanagement"
      :requestcommentaryregionalcontrol.sync="requestcommentaryregionalcontrol"
      :requestcommentaryregionalmanagement.sync="requestcommentaryregionalmanagement"
      :requestcommentarylocalcontrolvsProforma.sync="requestcommentarylocalcontrolvsProforma"
      :requestcommentarylocalcontrolvsForecast.sync="requestcommentarylocalcontrolvsForecast"
      :requestcommentarylocalmanagementvsProforma.sync="requestcommentarylocalmanagementvsProforma"
      :requestcommentarylocalmanagementvsForecast.sync="requestcommentarylocalmanagementvsForecast"
      @toggle-local-commentary-collapse="toggleLocalCommentaryCollapse"
      @toggle-local-commentary-reason-collapse="toggleLocalCommentaryReasonCollapse"
      @generate-ai="({ commentary, slot, mode }) => generateAI(commentary, slot, mode)"
      @generate-ai-summary="({ commentary, slot, mode }) => generateAIsummery(commentary, slot, mode)"
      @attachment-change="uploadAttachmentFile"
      @approve-commentary="approveCommentary"
      @reject-commentary="rejectCommentary($event)"
      @save-commentary="saveCommentary"
      @save-local-commentary="saveCommentary"
      @save-regional-commentary="saveRegionalCommentary"
      @save-local-reason="saveLocalApprovalReason"
      @save-regional-reason="saveRegionalApprovalReason"
      @commentary-display-ready="captureCommentaryBaselines"
      :saveLocalCommentaryLoading="saveLoading"
      :saveLocalCommentaryField="saveLocalCommentaryField"
      :saveRegionalCommentaryLoading="saveLoading"
      :saveRegionalCommentaryField="saveRegionalCommentaryField"
      :saveLocalReasonLoading="saveLocalReasonLoading"
      :saveRegionalReasonLoading="saveRegionalReasonLoading"
      :commentaryBaselines="commentaryBaselines"
      :commentaryBaselinesReady="commentaryBaselinesReady"
      @add-commentary="addCommentary"
    />

      <request-commentary-dialog
        v-if="requestcommentarydialog"
        v-model="requestcommentarydialog"
        :heading="bulksubmit ? 'Bulk Request Commentary' : 'Request Commentary'"
        :width="800"
        :loading="requestcommentaryloading"
        :bulksubmit="bulksubmit"
        :multiselectcount="multiselectdata.length"
        :selectedcommentary="selectedcommentary"
        :isapprover="isapprover"
        :isregionalapprover="isregionalapprover"
        :workflowtext="workflowtext"
        :workflows="workflows"
        :local-controls-label="local_controls_label"
        :local-management-label="local_management_label"
        :regional-controls-label="regional_controls_label"
        :regional-management-label="regional_management_label"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
        :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
        :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
        :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
        :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
        :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
        :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
        :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
        @request="requestCommentary"
        @update:requestcommentarylocalcontrolvsProforma="val => (requestcommentarylocalcontrolvsProforma = val)"
        @update:requestcommentarylocalmanagementvsProforma="val => (requestcommentarylocalmanagementvsProforma = val)"
        @update:requestcommentarylocalcontrolvsForecast="val => (requestcommentarylocalcontrolvsForecast = val)"
        @update:requestcommentarylocalmanagementvsForecast="val => (requestcommentarylocalmanagementvsForecast = val)"
        @update:requestcommentaryregionalcontrolvsProforma="val => (requestcommentaryregionalcontrolvsProforma = val)"
        @update:requestcommentaryregionalmanagementvsProforma="val => (requestcommentaryregionalmanagementvsProforma = val)"
        @update:requestcommentaryregionalcontrolvsForecast="val => (requestcommentaryregionalcontrolvsForecast = val)"
        @update:requestcommentaryregionalmanagementvsForecast="val => (requestcommentaryregionalmanagementvsForecast = val)"
      />

      <previous-cycle-list-dialog
        v-if="previouscyclelistdialog"
        v-model="previouscyclelistdialog"
        :loading="previouscyclelistloading"
        :previouscyclelist="previouscyclelist"
        :commentary-label="commentary_local_key_label"
        @select="getPreviousCycleData"
      />

      <previous-cycle-data-dialog
        v-if="previouscycledatadialog"
        v-model="previouscycledatadialog"
        :loading="previouscycledataloading"
        :previouscycledatatoupload="previouscycledatatoupload"
        :prevselected="prevcommentaryselect"
        :tablecolors="tablecolors"
        :cycletype="cycletype"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        :gl-code-label="$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code')"
        @update:selected-list="val => (prevcommentaryselect = val)"
        @upload="uploadPreviousCycleCommentary"
      />

      <reporting-unit-dialog
        v-if="userlistdialog"
        v-model="userlistdialog"
        :detail="commentaryrudata"
        :user-id="userid"
        heading="User List"
        :show-reporting-unit-details="false"
      />

     

      <net-sales-breakup-dialog
        v-if="clientbyclientdialog_netsales"
        v-model="clientbyclientdialog_netsales"
        :loading="clientbyclientloading_netsales"
        :width="max_netsales_revenue_dialog_width"
        :breakdown-data="breakdownData"
        :net-sales-view-mode="netSalesViewMode"
        :expanded-groups="expandedGroups"
        :clientbyclient-data="filteredClientbyClientDataNetSales"
        :clientbyclient-full-data="clientbyclientdata_netsales"
        :client-type-headers="clientTypeHeaders"
        :client-by-client-headers="clientbyclient_headers"
        :is-preparer="ispreparer"
        :is-pending-local="ispendinglocalruapproval"
        :is-pending-regional="ispendingregionalruapproval"
        :is-special-ru="isSpecialRu"
        @open-upload-commentary="handleOpenNetSalesUpload"
        @toggle-revenue-group="toggleRevenueGroup"
        @update:net-sales-view-mode="val => (netSalesViewMode = val)"
      />
      <upload-net-sales-commentary-dialog
        v-if="uploadnetsalescommentarydialog"
        v-model="uploadnetsalescommentarydialog"
        :loading="uploadnetsalescommentaryloading"
        :width="1500"
        :headers="[...clientbyclient_headers, { text: 'Message', value: 'message', lock: true }]"
        :items="uploadfiledata_netsales"
        :enableslot="['actual_amount', 'forecast_amount', 'proforma_amount', 'actual_vs_proforma_variance_amount', 'actual_vs_forecast_variance_amount', 'commentary1', 'commentary2', 'message']"
        :show-submit="!uploadclientbyclienterror && uploadfiledata_netsales.length > 0"
        :file-value="uploadclientbyblientfile"
        @file-change="processClientbyclientUploadFile('netsales')"
        @update:file-value="val => (uploadclientbyblientfile = val)"
        @download-template="downloadRevenueCommentaryTemplate('netsales')"
        @submit="uploadclientbyclientCommentary('netsales')"
      />

        <revenue-breakup-dialog
        v-if="clientbyclientdialog_revenue"
        v-model="clientbyclientdialog_revenue"
        :loading="clientbyclientloading_revenue"
        :width="max_netsales_revenue_dialog_width"
        :breakdown-data="breakdownData"
        :revenue-view-mode="revenueViewMode"
        :expanded-groups="expandedGroups"
        :clientbyclient-data="filteredClientbyClientDataRevenueBreakup"
        :clientbyclient-full-data="clientbyclientdata_revenue"
        :client-type-headers="DEMOAPPENABLED ? clientTypeHeadersDemoApp : clientTypeHeaders"
        :client-by-client-headers="clientbyclient_headers"
        :is-preparer="ispreparer"
        :is-pending-local="ispendinglocalruapproval"
        :is-pending-regional="ispendingregionalruapproval"
        :is-special-ru="isSpecialRu"
        :tablecolors="tablecolors"
        :selected-commentary="selectedcommentary"
        :revenue-ai-proforma="revenueAIProforma"
        :revenue-ai-forecast="revenueAIForecast"
        :revenue-ai-loading-proforma="revenueAILoadingProforma"
        :revenue-ai-loading-forecast="revenueAILoadingForecast"
        :is-typing="isTyping"
        :is-threshold-exceed-revenue-commentary="isThresholdExceedRevenueCommentary"
        :revenue-commentary-gen-ai-btntab="revenueCommentaryGenAiBtntab"
        :actual-label="actual_label"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        @open-upload-commentary="handleOpenRevenueUpload"
        @toggle-revenue-group="toggleRevenueGroup"
        @update:revenue-view-mode="val => (revenueViewMode = val)"
        @generate-ai="payload => generateAIRevenue(payload.commentary || selectedcommentary, payload.mode, payload.forecastType)"
        @update:revenue-ai-proforma="val => (revenueAIProforma = val)"
        @update:revenue-ai-forecast="val => (revenueAIForecast = val)"
      />

      <upload-revenue-commentary-dialog
        v-if="uploadrevenuecommentarydialog"
        v-model="uploadrevenuecommentarydialog"
        :loading="uploadrevenuecommentaryloading"
        :upload-data="uploadfiledata_revenue"
        :headers="clientbyclient_headers"
        :has-error="uploadclientbyclienterror"
        @file-change="processClientbyclientUploadFile('revenue')"
        @download-template="downloadRevenueCommentaryTemplate('revenue')"
        @submit="uploadclientbyclientCommentary('revenue')"
      />
      
      <WarningDialog
        v-if="showErrorMessageDialog"
        v-model="showErrorMessageDialog"
        :message="errorMessageDialogContent"
        title="Important Notice"
        icon="mdi-alert"
        icon-color="error"
        button-text="Close"
        button-color="error"
        :width="800"
        @close="handleDialogClose"
      />
      <activity-log-dialog
        v-if="activitylogdialog"
        v-model="activitylogdialog"
        :loading="activitylogloading"
        :activitylogdata="activitylogdata"
        :reporting-type="reportingType || ''"
        :activitylogconfig="activitylogconfiggl"
      />

      <custom-filters-dialog
        v-if="customfiltersdialog"
        v-model="customfiltersdialog"
        :searchcustom="searchcustom"
        :customfilter="customfilter"
        :commentarydata="commentarydata"
        @update:searchcustom="val => (searchcustom = val)"
        @update:customfilter="val => (customfilter = val)"
        @save="saveCustomFilter"
      />
      <r-u-approval-dialog
        v-if="ruapprovaldialog"
        v-model="ruapprovaldialog"
        :loading="ruapprovalloading"
        :heading="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU') + ' level approval'"
        :approval-type="ruapprovaltype"
        :note="rulevelapprovenote"
        :eligible-reporting-units="eligibleReportingUnitsForApproval"
        @update:note="val => (rulevelapprovenote = val)"
        @proceed="approveRU"
      />

      <all-units-data-download-dialog
        v-if="allrudownloaddialog"
        v-model="allrudownloaddialog"
        :loading="allrudownloadloading"
        :years-list="yearsList"
        :download-period-list="downloadperiodlist"
        :current-year="allRUDownloadYear"
        :current-period="allRUDownloadPeriod"
        :downloads="allrudownloadlist"
        @update:year="val => (allRUDownloadYear = val)"
        @update:period="val => (allRUDownloadPeriod = val)"
        @generate="downloadAllRU"
        @download="downloadAllRU"
      />

      <r-u-cycle-download-dialog
        v-if="allrucycledownloaddialog"
        v-model="allrucycledownloaddialog"
        :loading="allrucycledownloadloading"
        :heading="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU') + ' Cycle Approval Reports'"
        :years-list="yearsList"
        :download-period-list="downloadperiodlist"
        :current-year="allRUDownloadYear"
        :current-period="allRUDownloadPeriod"
        :downloads="allrucycledownloadlist"
        @update:all-ru-download-year="val => (allRUDownloadYear = val)"
        @update:all-ru-download-period="val => (allRUDownloadPeriod = val)"
        @generate="downloadAllRUcycle"
        @download="downloadAllRUcycle"
      />

      <lb-dialog v-if="workflowsdialog" v-model="workflowsdialog" :loading="allrucycledownloadloading" heading="Workflows status" width="600">
        <template v-slot:body>
          <WorkflowsStatus
            :allworkflowstext="allworkflowstext"
            :workflowtext="workflowtext"
            :allworkflowskeys="allworkflowskeys"
            :sodEnabled="isSodEnabled"
          />
        </template>
      </lb-dialog>

      <status-insights-dialog
        v-if="statusinsightsdialog"
        v-model="statusinsightsdialog"
        :commentarycycledata="commentarycycledata"
        :commentarysummarydata="commentarysummarydata"
        :workflows="workflows"
        :commentary_local_key_label="commentary_local_key_label"
        :commentary_regional_key_label="commentary_regional_key_label"
        :ruLabel="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')"
        :allworkflowstext="allworkflowstext"
        :workflowtext="workflowtext"
        :allworkflowskeys="allworkflowskeys"
        :isSodEnabled="isSodEnabled"
        :isBulkApproveEnabled="isbulkapprovalcrosscontrolenabled || isbulkapprovalmanagementcontrolenabled"
        :isRegionalAutoSubmissionEnabled="isRegionalCommentaryAutomationEnabled"
      />

      <bulk-preview-add-commentary-dialog
      v-if="previewBulkAddCommentarydialog"
      v-model="previewBulkAddCommentarydialog"
      :file-data="bulksubmitfiledata"
      :headers="bulkUploadCommentaryHeaders"
      :loading="bulksubmitloading"
      :is-preparer="ispreparer"
      :workflows="workflows"
      @submit="bulkUploadCommentaryByGL(true)"
    />

      <pdf-download-dialog
        v-if="rucyclepdfdownloaddialog"
        v-model="rucyclepdfdownloaddialog"
        :loading="rucyclepdfdownloadloading"
        :items="rucyclepdfdownloadlist"
        @generate="pdfdownloadRUcycleGenerate"
        @download="downloadRUPdfFile"
        @refresh="getpdfFun"
      />

      <RevenueBreakupDetailedInformation
        v-if="revenueDetailDialog"
        v-model="revenueDetailDialog"
        :selectedRevenueDetail="selectedRevenueDetail"
        :proformaShortformLabel="proforma_shortform_label"
        :forecastShortformLabel="forcast_shortform_label"
        :tablecolors="tablecolors"
        @close="revenueDetailDialog = false"
      />
      
  </div>
</template>
<script>
import CycleHeader from './components/CycleHeader.vue';
import Breadcrumbs from '../../components/Breadcrumbs.vue';
import cfilter from '../Filter'
import RUList from './List'
import varianceAnalysisConstants from "../../constants"
// let xlsx = require('xlsx');
import { Chart, LineController, LineElement, PointElement, Title, Tooltip, CategoryScale, LinearScale, BarController, BarElement, Legend } from 'chart.js';
Chart.register(LineController, LineElement, PointElement, Title, Tooltip, CategoryScale, LinearScale, BarController, BarElement, Legend);
import WarningDialog from '../../components/WarningDialog.vue';

import WorkflowsStatus from "../../components/WorkflowDialog.vue"
import RevenueBreakupDetailedInformation from '../../components/RevenueBreakupDetailedInformation.vue';
import RUViewToolbar from '../../components/RUViewToolbar.vue';
import RUDataSection from "../../components/RUDataSection.vue";
import ReportingUnitDialog from '../MyReportingUnit/components/ReportingUnitDialog.vue';
import NetSalesBreakupDialog from '../../modals/NetSalesBreakupDialog.vue';
import RevenueBreakupDialog from '../../modals/RevenueBreakupDialog.vue';
import EmailReminderDialog from '../../modals/EmailReminderDialog.vue';
import PreviousCycleListDialog from '../../modals/PreviousCycleListDialog.vue';
import PreviousCycleDataDialog from '../../modals/PreviousCycleDataDialog.vue';
import RequestCommentaryDialog from '../../modals/RequestCommentaryDialog.vue';
import PdfDownloadDialog from '../../modals/PdfDownloadDialog.vue';
import BulkPreviewAddCommentaryDialog from '../../modals/BulkPreviewAddCommentaryDialog.vue'; // Add this import
import CustomFiltersDialog from '../../modals/CustomFiltersDialog.vue';
import ActivityLogDialog from '../../modals/ActivityLogDialog.vue';
import RUCycleDownloadDialog from '../../modals/RUCycleDownloadDialog.vue';
import AllUnitsDataDownloadDialog from '../../modals/AllUnitsDataDownloadDialog.vue';
import UploadNetSalesCommentaryDialog from '../../modals/UploadNetSalesCommentaryDialog.vue';
import RUApprovalDialog from '../../modals/RUApprovalDialog.vue';
import UploadRevenueCommentaryDialog from '../../modals/UploadRevenueCommentaryDialog.vue';
import StatusHelpDialog from '../../modals/StatusHelpDialog.vue';
import StatusInsightsDialog from '../../modals/StatusInsightsDialog.vue';
import BulkApproveLocalDialog from '../../modals/BulkApproveLocalDialog.vue';
import BulkUploadCommentaryApproverDialog from '../../modals/BulkUploadCommentaryApproverDialog.vue';
import CommentaryDialog from '../../modals/CommentaryDialog.vue'; // ADD THIS IMPORT
import { getStatusLabelByCode } from '../../utils/statusHelpers';





import { mapActions } from 'vuex';
import helpers from '../../utils/helpers';
import { SL_COMMENTARY } from '../../utils/constants';

export default {
  name: 'commentaryworking',
  data: function () {
    return {
      pageame: "cycle_page",
      loading: false,
      /** @type {Boolean} Separate loading state for RU List - only tracks getreportingunit_pagination API */
      isRUListLoading: false,
      /** @type {AbortController|null} AbortController for getreportingunitdata API - used to cancel previous pending requests */
      loadDataAbortController: null,
      /** @type {Number} Request token to track the current loadData request and ignore stale responses */
      loadDataRequestToken: 0,
      userid: '',
      toggleview: 0,
      toggletableview: 0,
      ispreparer: false,
      isapprover: false,
      ispendinglocalruapproval: false,
      ispendingregionalruapproval: false,
      isregionalapprover: false,
      ismanager: false,
      isviewonly: false,
      cyclestage: 0,
      commentarydata: [],
      commentarydatajson: {},
      commentarydatajsonById: {},
      commentarydatajsonByGLCode: {},
      commentaryrudata: {},
      commentarycycledata: {},
      commentarysummarydata: {},
      commentarylocalsummarydata: {},
      commentaryregionalsummarydata: {},
      gllist: {},
      // selectedfilter moved to computed property for Vuex persistence
      hierarchyData: {},
      /** @type {String} Reporting type filter for API - 'bs' for Balance Sheet, null/empty for P&L */
      reportingType: '',
      selectedrole: "",
      role: [],
      rolelist: {},
      selectedyear: 2023,
      year: [],
      yearlist: {},
      yearsList: [],
      selectedperiod: "",
      period: [],
      perioddata: [],
      periodlist: {},
      selectednetwork: "all",
      network: [],
      networkdata: [],
      networklist: {},
      selectedregion: "all",
      region: [],
      regiondata: [],
      regionlist: {},
      selectedcountry: "all",
      country: [],
      countrydata: [],
      selectedreportingunit: "",
      reportingunit: [],
      reportingunitdata: [],
      reportingunitlist: {},
      statushelpdialog: false,
      commantorydialog: false,
      bulktype: "",
      bulksubmit: false,
      bulkcommentall: false,
      bulkcommentreplace: false,
      viewdialog: false,
      viewdata: {},
      selectedcommentary: {},
      revenueAIProforma:"",
      revenueAIForecast:"",
      summaryAiProforma:"",
      summaryAiForecast:"",
      revenueAILoadingProforma:false,
      revenueAILoadingForecast:false,
      revenueairesopone:false,
      fullText: "",
      revenueAIResponseText: "",
      displayedText: "",
      loadingtext1: false,
      loadingtext2: false,
      index: 0,
      speed: 0, // Typing speed in milliseconds
      isTyping: false,
      aitext: "", // Ensure aitext is defined for typeEffectRevenue
      shouldStop:false,
      commentaryloading: false,
      saveLoading: false,
      saveLocalCommentaryField: '',
      saveRegionalCommentaryField: '',
      saveLocalReasonLoading: false,
      saveRegionalReasonLoading: false,
      commentaryBaselines: {},
      commentaryBaselinesReady: false,
      commentarytype: '',
      requestcommentarydialog: false,
      requestcommentaryloading: false,
      confirmEmailReminderDialog: false,
      emailReminderMode: 'reportingUnits', // 'reportingUnits' or 'cycles'
      emailreminderdialogloading: false,
      pageSize: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
      //workflows old flags
      requestcommentarylocalcontrol: false,
      requestcommentarylocalmanagement: false,
      requestcommentaryregionalcontrol: false,
      requestcommentaryregionalmanagement: false,
      //workflows new flags for request commentary 
      requestcommentarylocalcontrolvsProforma: false,
      requestcommentarylocalmanagementvsProforma: false,
      requestcommentaryregionalcontrolvsProforma: false,
      requestcommentaryregionalmanagementvsProforma: false,
      requestcommentarylocalcontrolvsForecast: false,
      requestcommentarylocalmanagementvsForecast: false,
      requestcommentaryregionalcontrolvsForecast: false,
      requestcommentaryregionalmanagementvsForecast: false,
      // approvecommentarydialog: false,
      // rejectcommentarydialog: false,
      // commentslevel: "",
      // commentsdialog: false,
      // commentsloading: false,
      trendchartdataset: [],
      trendchart: null,
      charttab: 0,
      tablecolors: {
        heading: { "a": "", "b": "" },
        body: { "a": "", "b": "" }
      },
      // commentsdata: '',
      // commentserror: '',
      multiselectdata: [],
      activitylogdialog: false,
      activitylogloading: false,
      activitylogdata: [],
      bulksubmitfiledatafile: null,
      approverBulkSubmitDataFile: null,
      bulksubmitfiledata: {},
      approverBulkSubmitData: {},
      bulksubmitfiledataList: [],
      approverBulkSubmitFileDataListis: [],
      bulksubmitfiledataerror: false,
      bulksubmitfiledataerrorisApprover: false,
      bulksubmitfiledataerrorisApprover15Characters: false,
      bulksubmitdialog: false,
      approverBulkSubmitPop:false,
      bulksubmitloading: false,
      approverBulkSubmitLoading: false,
      bulksubmitcolumns: [],
      bulkapprovelocalfiledatafile: null,
      bulkapprovelocalfiledata: {},
      bulkapprovelocalfiledataerror: false,
      bulkapprovelocaldialog: false,
      bulkapprovelocalloading: false,
      expandedsubcategory: [],
      customfilter: [],
      searchcustom: "",
      customfiltersdialog: false,
      customfilterstoggle: false,
      userlistdialog: false,
      workflowtext: [],
      activitylogconfigcycle: {
        cycleopen: { icon: "mdi-circle-outline", color: "grey" },
        cycleclose: { icon: "mdi-circle", color: "grey" },
        ru_network_change: { icon: "mdi-swap-horizontal", color: "warning" },
      },
      activitylogconfiggl: {
        a_localbulkadd: { icon: "mdi-plus-circle", color: "info" },
        a_localadd: { icon: "mdi-plus-circle", color: "info" },
        a_localfileadd: { icon: "mdi-plus-circle", color: "info" },
        a_localfileapprove: { icon: "mdi-check-circle", color: "info" },
        a_localapprove: { icon: "mdi-check-circle", color: "success" },
        a_localbulkapprove: { icon: "mdi-check-circle", color: "success" },
        a_localreject: { icon: "mdi-close-circle", color: "error" },
        a_localbulkreject: { icon: "mdi-close-circle", color: "error" },
        a_localrequest: { icon: "mdi-comment-plus", color: "grey" },
        a_regionaladd: { icon: "mdi-plus-circle-outline", color: "info" },
        a_regionalapprove: { icon: "mdi-check-circle-outline", color: "success" },
        a_regionalreject: { icon: "mdi-close-circle-outline", color: "error" },
        a_regionalrequest: { icon: "mdi-comment-plus-outline", color: "grey" },
        a_localproformasaved: { icon: "mdi-content-save", color: "info" },
        a_localforecastsaved: { icon: "mdi-content-save", color: "info" },
        a_regionalproformasaved: { icon: "mdi-content-save", color: "info" },
        a_regionalforecastsaved: { icon: "mdi-content-save", color: "info" },
        a_regionalreasonsaved: { icon: "mdi-content-save", color: "info" },
        a_localreasonsaved: { icon: "mdi-content-save", color: "info" },
        f_localbulkadd: { icon: "mdi-plus-circle", color: "info" },
        f_localadd: { icon: "mdi-plus-circle", color: "info" },
        f_localfileadd: { icon: "mdi-plus-circle", color: "info" },
        f_localfileapprove: { icon: "mdi-check-circle", color: "info" },
        f_localapprove: { icon: "mdi-check-circle", color: "success" },
        f_localbulkapprove: { icon: "mdi-check-circle", color: "success" },
        f_localreject: { icon: "mdi-close-circle", color: "error" },
        f_localbulkreject: { icon: "mdi-close-circle", color: "error" },
        f_localrequest: { icon: "mdi-comment-plus", color: "grey" },
        f_regionaladd: { icon: "mdi-plus-circle-outline", color: "info" },
        f_regionalapprove: { icon: "mdi-check-circle-outline", color: "success" },
        f_regionalreject: { icon: "mdi-close-circle-outline", color: "error" },
        f_regionalrequest: { icon: "mdi-comment-plus-outline", color: "grey" },
        f_localproformasaved: { icon: "mdi-content-save", color: "info" },
        f_localforecastsaved: { icon: "mdi-content-save", color: "info" },
        f_regionalproformasaved: { icon: "mdi-content-save", color: "info" },
        f_regionalforecastsaved: { icon: "mdi-content-save", color: "info" },
        f_regionalreasonsaved: { icon: "mdi-content-save", color: "info" },
        f_localreasonsaved: { icon: "mdi-content-save", color: "info" },
      },
      alluserassigned: true,
      clientbyclientdialog_netsales: false,
      clientbyclientloading_netsales: false,
      clientbyclientdata_netsales: [],
      filteredClientbyClientDataNetSales: [],
      filteredClientbyClientDataRevenueBreakup: [],
      clientbyclientdialog_revenue: false,
      clientbyclientloading_revenue: false,
      clientbyclientdata_revenue: [],
      filteredClientbyClientDataRevenue: [],
      isMailRemainderRequired: false,
      /** @type {'forward'|'back'} Direction for RUList ↔ RUDataSection slide transition */
      viewTransitionDirection: 'forward',
      varianceAnalysisConstants,
      clientbyclient_headers: [
        {
          value: "cl_code",
          text: "Client Code",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "client_name",
          text: "Client Name",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "actual_amount",
          text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actuals'),
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "proforma_amount",
          text: `${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_proforma_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary1",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "forecast_amount",
          text: `${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_forecast_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary2",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
      ],
      clientbyclient_headersDemoapp: [
        {
          value: "cl_code",
          text: "Client Code",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "client_name",
          text: "Client Name",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "actual_amount",
          text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actuals'),
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "proforma_amount",
          text: `${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_proforma_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary1",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "forecast_amount",
          text: `${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_forecast_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary2",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "actions",
          text: "Actions",
          sortable: false,
          filterable: false,
          lock: true,
          align: 'center',
          width: '80px',
        },
      ],
      breakdownData: [],
      expandedGroups: [],
      clientTypeHeaders: [
        { text: this.$nova.labelsName('cycle_page','client_name','Client Name'), value: '_id', sortable: false, width: '15%' },
        { text: this.$nova.labelsName('cycle_page','client_code','Client Code'), value: 'clientCode', sortable: false, width: '5%' },
        { text: this.$nova.labelsName('cycle_page','actual_label','Actuals'), value: 'actual_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page','proforma_shortform_label','Proforma') + " Amount", value: 'proforma_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Amt", value: 'actual_vs_proforma_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Com", value: 'actual_vs_proforma_commentary', sortable: false, width: '17%' },
        { text: this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amount", value: 'forecast_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amt", value: 'actual_vs_forecast_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Com", value: 'actual_vs_forecast_commentary', sortable: false, width: '17%' },
      ],
      clientTypeHeadersDemoApp: [
        { text: this.$nova.labelsName('cycle_page','client_name','Client Name'), value: '_id', sortable: false, width: '15%' },
        { text: this.$nova.labelsName('cycle_page','client_code','Client Code'), value: 'clientCode', sortable: false, width: '5%' },
        { text: this.$nova.labelsName('cycle_page','actual_label','Actuals'), value: 'actual_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page','proforma_shortform_label','Proforma') + " Amount", value: 'proforma_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Amt", value: 'actual_vs_proforma_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Com", value: 'actual_vs_proforma_commentary', sortable: false, width: '17%' },
        { text: this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amount", value: 'forecast_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amt", value: 'actual_vs_forecast_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Com", value: 'actual_vs_forecast_commentary', sortable: false, width: '17%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '5%', align: 'center' },
      ],
      netSalesViewMode:"grouped",
      revenueViewMode:"grouped",
      islocalapproverinru: false,
      isregionalapproverinru: false,
      selectedlocalapproval: [],
      selectedregionalapproval: [],
      ruapprovaltype: "",
      ruapprovaldialog: false,
      ruapprovalloading: false,
      commentarycycledatalist: {},
      regionaldata: [],
      page: 1,
      pagecount: 1,
      perpage: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
      previouscyclelistdialog: false,
      previouscyclelistloading: false,
      previouscyclelist: [],
      previouscycledatadialog: false,
      previouscycledataloading: false,
      previouscycledata: [],
      previouscyclemetadata: {},
      previouscycledatatoupload: [],
      uploadrevenuecommentarydialog: false,
      uploadrevenuecommentaryloading: false,
      uploadnetsalescommentarydialog: false,
      uploadnetsalescommentaryloading: false,
      uploadfiledata_revenue: [],
      uploadfiledata_netsales: [],
      uploadclientbyblientfile: null,
      uploadclientbyclienterror: false,
      prevcommentaryselect: [],
      allrudownloaddialog: false,
      allrudownloadloading: false,
      allrudownloadlist: [],
      allRUDownloadPeriod: null,
      allRUDownloadYear: null,
      attachmentfile: null,
      attachmentfileloading: false,
      attachmentfilepercentage: 0,
      commentarySubmitDialogueViewMode: false,
      reportingUnitType:'',
      // is_selected_all_filter:true,
      pagination_page: 0,
      reportingUnitsTotalCount: 0,
      reportingUnitsCurrentPage: 1,
      reportingUnitFilter: {},
      isReportingUnitClicked: false,
      hasMoreReportingUnits: false,
      reportingUnitRequestToken: 0, // Token to track latest API request and prevent race conditions
      filterDataPage: 0,
      filterData: {},
      tableApiFilters: {}, // Stores filters from the table component (userRole, etc.) to be sent in API calls
      isFilteredData: false,
      commentarydataList: {},
      periodDataList: [],
      networkList: [],
      regionList: [],
      countrylist: [],
      lastUpdatedAt: "",
      appname: '',
      downloadperiodlist: [],
      isGlMandatoryRequestFlag: false,
      replaceExistingCommentFlag: false,
      isbulkapprovalcrosscontrolenabled: false,
      isbulkapprovalmanagementcontrolenabled: false,
      total:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.TOTAL,
      local:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.LOCAL,
      lastActionsOnGL: { 'localaction': { type: 'none' }, 'regionalaction': { type: 'none' } },
      rulevelapprovenote: "",
      isFiltersDataLoading: false,
      reportingUnitsForMailReminder: [],
      isLocalCommentaryCollapsed:false,
      isLocalCommentaryReasonCollapsed:false,
      bulkUploadCommentaryHeaders: [
        {
          "text": "",
          "value": "ignore",
        },
        {
          "text": this.$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code'),
          "value": "code",
          "filterable": true
        },
        {
          "text": "GL Description",
          "value": "name",
          "filterable": true
        },
        {
          "text": "Commentary 1",
          "value": "commentary1"
        },
        {
          "text": "Commentary 2",
          "value": "commentary2"
        },
        {
          "text": "Message",
          "value": "message",
          "filterable": true
        }
      ],
      bulkUploadCommentaryisApproverHeaders: [
        {
          "text": "",
          "value": "ignore",
        },
        {
          "text": this.$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code'),
          "value": "code",
          "filterable": true
        },
        {
          "text": "GL Description",
          "value": "name",
          "filterable": true
        },
        {
          "text": this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') +  "Commentary 1",
          "value": "commentary1"
        },
        {
          "text": this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + "Commentary 2",
          "value": "commentary2"
        },
        {
          "text": "Message",
          "value": "message",
          "filterable": true
        }
      ],
      isDataRefreshed: false,
      workflows: { "lcp": true, "lmp": true, "rcp": true, "rmp": true, "lcf": true, "lmf": true, "rcf": true, "rmf": true },
      workflowsDisabledMessage: "Workflows Disabled",
      allrucycledownloaddialog: false,
      rucyclepdfdownloaddialog: false,
      rucyclepdfdownloadloading: false,
      allrucycledownloadloading: false,
      allrucycledownloadlist: [],
      rucyclepdfdownloadlist: [],
      allRUcycleDownloadPeriod: null,
      workflowsdialog: false,
      statusinsightsdialog: false,
      aggregatedLabelText:this.$nova.labelsName('cycle_page', 'commentary_aggregated_key_label', 'Aggregated'),
      allworkflowstext: [this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' control ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' control ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'), this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' management ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' management ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'),
      this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' control ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' control ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'), this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' management ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' management ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
      ],
      allworkflowskeys:['Local control proforma','Local control forecast', 'Local management proforma', 'Local management forecast',
        'Regional control proforma', 'Regional control forecast','Regional management proforma', 'Regional management forecast',
        'Local control proforma bs', 'Local control forecast bs', 'Local management proforma bs', 'Local management forecast bs',
        'Regional control proforma bs', 'Regional control forecast bs', 'Regional management proforma bs', 'Regional management forecast bs'
      ],
      previewBulkAddCommentary: [],
      previewBulkAddCommentarydialog: false,
      isReportingUnitdataloading: false,
      max_netsales_revenue_dialog_width: 1000,
      cycletypeReadview: 'Proforma',
      cycletypeItem: [{ text: this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), value: 'Proforma' },
      { text: this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'), value: 'Forecast' }
      ],
      isCommentaryView: false,
      expandedIds: new Set(),
      isFilterSet: false,
      local_controls_label: this.$nova.labelsName('cycle_page', 'local_control_label', 'Local Control'),
      local_management_label: this.$nova.labelsName('cycle_page', 'local_management_label', 'Local Management'),
      regional_controls_label: this.$nova.labelsName('cycle_page', 'regional_control_label', 'Regional Control'),
      regional_management_label: this.$nova.labelsName('cycle_page', 'regional_management_label', 'Regional Management'),
      commentary_local_key_label: this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local'),
      commentary_regional_key_label: this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional'),
      isAllExpanded: false,
      startIndex: 0,
      endIndex: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE - 1,
      incrementBy: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
      showSummaryTab: false,
      localCommentaryGenAiBtntab: false,
      isThresholdExceedJVSummarisation: false,
      isThresholdExceedLocalCommentary: false,
      revenueCommentaryStatus: {},
      revenueCommentaryGenAiBtntab: false,
      isThresholdExceedRevenueCommentary: false,
      isRegionalCommentaryAutomationEnabled: false,
      showErrorMessageDialog:false,
      errorMessageDialogContent:'',
      isSodEnabled:true,
      ruRoleOptions:[],
      selectedRuRole:null,
      multiRoleUsers: new Set(), 
      revenueDetailDialog: false,
      selectedRevenueDetail: null,
      DEMOAPPENABLED: process.env.VUE_APP_ENVIRONMENT === 'demoapp',
    }
  },
  props: {
    cycletype: {
      type: String,
      default: '',
    },
  },
  components: {
    CycleHeader,
    Breadcrumbs,
    cfilter,
    RUList,
    WarningDialog,
    WorkflowsStatus,
    RevenueBreakupDetailedInformation,
    RUViewToolbar,
    RUDataSection,
    ReportingUnitDialog,
    BulkPreviewAddCommentaryDialog,
    AllUnitsDataDownloadDialog,
    PdfDownloadDialog,
    CustomFiltersDialog,
    RUCycleDownloadDialog,
    RUApprovalDialog,
    ActivityLogDialog,
    StatusHelpDialog,
    StatusInsightsDialog,
    UploadNetSalesCommentaryDialog,
    NetSalesBreakupDialog,
    RevenueBreakupDialog,
    EmailReminderDialog,
    PreviousCycleListDialog,
    PreviousCycleDataDialog,
    RequestCommentaryDialog,
    UploadRevenueCommentaryDialog,
    BulkApproveLocalDialog,
    BulkUploadCommentaryApproverDialog,
    CommentaryDialog,
  },
  // activated() {
  //   // Check if we're coming back from GLBreakdown - skip refresh if so
  //   // Note: State restoration is handled in mounted() hook
  //   if (this.$store.state.varianceanalysis.skipReloadOnBack) {
  //     // Don't reset flag here - let mounted() handle it for full state restoration
  //     return;
  //   }
  //   this.refreshData();
  // },
  async mounted() {
    this.appname = "m_" + (this.$route.path || "").split("/")[1] || "";
    
    // Check if we're coming back from GLBreakdown - restore state and skip refresh if so
    const isComingBack = this.$store.state.varianceanalysis.skipReloadOnBack;
    
    if (isComingBack) {
      // Restore page state from store
      const savedState = this.$store.state.varianceanalysis.basePageState;
      if (savedState) {
        // Restore all saved state properties
        this.commentarydata = savedState.commentarydata || [];
        this.commentarydatajson = savedState.commentarydatajson || {};
        this.commentarydatajsonById = savedState.commentarydatajsonById || {};
        this.commentarydatajsonByGLCode = savedState.commentarydatajsonByGLCode || {};
        this.commentaryrudata = savedState.commentaryrudata || {};
        this.commentarycycledata = savedState.commentarycycledata || {};
        this.commentarysummarydata = savedState.commentarysummarydata || {};
        this.commentarylocalsummarydata = savedState.commentarylocalsummarydata || {};
        this.commentaryregionalsummarydata = savedState.commentaryregionalsummarydata || {};
        this.hierarchyData = savedState.hierarchyData || {};
        this.selectedrole = savedState.selectedrole || '';
        const restoredYear = savedState.selectedyear;
        this.selectedyear = restoredYear === 'all' ? 'all' : (Number(restoredYear) || 2023);
        this.selectedperiod = savedState.selectedperiod || '';
        this.selectednetwork = savedState.selectednetwork || 'all';
        this.selectedregion = savedState.selectedregion || 'all';
        this.selectedcountry = savedState.selectedcountry || 'all';
        this.selectedreportingunit = savedState.selectedreportingunit || '';
        this.toggleview = savedState.toggleview !== undefined ? savedState.toggleview : 0;
        this.toggletableview = savedState.toggletableview !== undefined ? savedState.toggletableview : 0;
        this.ispreparer = savedState.ispreparer || false;
        this.isapprover = savedState.isapprover || false;
        this.isregionalapprover = savedState.isregionalapprover || false;
        this.ismanager = savedState.ismanager || false;
        this.isviewonly = savedState.isviewonly || false;
        this.cyclestage = savedState.cyclestage || 0;
        this.customfilter = savedState.customfilter || [];
        this.customfilterstoggle = savedState.customfilterstoggle || false;
        this.ispendinglocalruapproval = savedState.ispendinglocalruapproval || false;
        this.ispendingregionalruapproval = savedState.ispendingregionalruapproval || false;
        this.gllist = savedState.gllist || {};
        this.tablecolors = savedState.tablecolors || { heading: { "a": "#d0dcff", "b": "#efcef4" }, body: { "a": "", "b": "" } };
        this.period = savedState.period || [];
        this.perioddata = savedState.perioddata || [];
        this.periodlist = savedState.periodlist || {};
        this.network = savedState.network || [];
        this.networkdata = savedState.networkdata || [];
        this.networklist = savedState.networklist || {};
        this.region = savedState.region || [];
        this.regiondata = savedState.regiondata || [];
        this.regionlist = savedState.regionlist || {};
        this.country = savedState.country || [];
        this.countrydata = savedState.countrydata || [];
        this.reportingunit = savedState.reportingunit || [];
        this.reportingunitdata = savedState.reportingunitdata || [];
        this.reportingunitlist = savedState.reportingunitlist || {};
        
        // Restore cache data to prevent API calls
        this.commentarydataList = savedState.commentarydataList || {};
        this.filterData = savedState.filterData || [];
        this.periodDataList = savedState.periodDataList || [];
        this.networkList = savedState.networkList || [];
        this.regionList = savedState.regionList || [];
        this.countrylist = savedState.countrylist || [];

        // Restore role-related state for SOD (critical for maintaining preparer/approver access)
        this.isSodEnabled = savedState.isSodEnabled !== undefined ? savedState.isSodEnabled : true;
        this.ruRoleOptions = savedState.ruRoleOptions || [];
        
        // Check if selectedRuRole was updated in GLBreakdown (stored in SLData)
        const slData = this.$store.state.varianceanalysis.SLData || {};
        if (slData.selectedRuRole) {
          this.selectedRuRole = slData.selectedRuRole;
        } else {
          this.selectedRuRole = savedState.selectedRuRole || null;
        }
        
        // Restore Regional Commentary Automation state
        this.isRegionalCommentaryAutomationEnabled = savedState.isRegionalCommentaryAutomationEnabled || false;
        // Restore bulk submit columns for Excel download
        this.bulksubmitcolumns = savedState.bulksubmitcolumns || [];
        // Restore workflow state
        this.workflows = savedState.workflows || { "lcp": true, "lmp": true, "rcp": true, "rmp": true, "lcf": true, "lmf": true, "rcf": true, "rmf": true };
        this.workflowtext = savedState.workflowtext || [];
        // Restore RU approval state
        this.islocalapproverinru = savedState.islocalapproverinru || false;
        this.isregionalapproverinru = savedState.isregionalapproverinru || false;
        // Restore view state
        this.isReportingUnitClicked = savedState.isReportingUnitClicked || false;
        // Restore reportingType for statement tab filtering
        this.reportingType = savedState.reportingType || '';
        // Restore view options toolbar state
        if (savedState.isCommentaryView !== undefined) this.isCommentaryView = savedState.isCommentaryView;
        if (savedState.cycletypeReadview !== undefined) this.cycletypeReadview = savedState.cycletypeReadview;
        
        // Ensure userid is set from store (needed for role checks)
        this.userid = this.$store.state.user.id;
        
        // Clear the saved state after restoration
        this.$store.commit('varianceanalysis/clearBasePageState');
        
        // Reload the data to get fresh values after returning from GLBreakdown
        // This ensures any changes made in GLBreakdown (commentary updates, approvals, etc.) are reflected
        this.$nextTick(() => {
          this.loadData(true);
        });
      }
      
      // Delay clearing the flag until next tick so child components (like cfilter) 
      // can also check it during their mounted() hooks
      this.$nextTick(() => {
        this.$store.commit('varianceanalysis/setSkipReloadOnBack', false);
      });
    } else {
      this.refreshData();
    }
    
    let colors2 = this.$nova.getColors(3, 0.08);
    // Only set tablecolors if not restored from saved state
    if (!this.tablecolors || !this.tablecolors.body || !this.tablecolors.body.a) {
      this.tablecolors = {
        heading: { "a": "#d0dcff", "b": "#efcef4" },
        body: { "a": colors2[2], "b": colors2[1] }
      }
    }
    
    const featuresData = await this.$store.dispatch('varianceanalysis/fetchAiFeatures', this.axios);
    const features = Array.isArray(featuresData) ? featuresData : [];

    const summaryStatus = features.find(feature => feature?.name === 'jv_summarisation');
    this.summaryStatus = summaryStatus;
    this.showSummaryTab = summaryStatus?.platform_admin_enabled && summaryStatus?.super_admin_enabled;
    const localCommentaryStatus  = features.find(feature => feature?.name === 'local_commentary_summary');
    this.localCommentaryStatus = localCommentaryStatus;
    this.localCommentaryGenAiBtntab = localCommentaryStatus?.platform_admin_enabled && localCommentaryStatus?.super_admin_enabled;

     const revenueCommentaryStatus  = features.find(feature => feature?.name === 'revenue_commentary_summary');
    this.revenueCommentaryStatus = revenueCommentaryStatus;
    this.revenueCommentaryGenAiBtntab = revenueCommentaryStatus?.platform_admin_enabled && revenueCommentaryStatus?.super_admin_enabled;
    const isThresholdExceedRevenueCommentary = revenueCommentaryStatus?.isExceed;
    this.isThresholdExceedRevenueCommentary = isThresholdExceedRevenueCommentary;

    const isThresholdExceedJVSummarisation = summaryStatus?.isExceed;
    this.isThresholdExceedJVSummarisation = isThresholdExceedJVSummarisation;
    const isThresholdExceedLocalCommentary = localCommentaryStatus?.isExceed;
    this.isThresholdExceedLocalCommentary = isThresholdExceedLocalCommentary;
    
    // Setup scroll-based lazy loading for the data table
    this.setupLazyLoading();
  },
  created() {
    // Ensure helpers.loadContent is always bound to this Vue instance
    if (typeof this.loadContent === 'function' && this.loadContent.bind) {
      this.loadContent = this.loadContent.bind(this);
    }
  },
  methods: {
    ...helpers,
    ...mapActions('varianceanalysis', {
      saveSlCommentaryAction: 'saveSlCommentary',
      saveRegionalApprovalReasonAction: 'saveRegionalApprovalReason',
    }),
    /**
     * Get status label by status code
     * Wraps the imported utility function for use in computed properties
     * @param {Number|String} code - The status code
     * @returns {String} The status label
     */
    getStatusLabelByCode(code) {
      return getStatusLabelByCode(code);
    },
    handleRefreshData() {
      this.loadContent(true);
    },
    /**
     * Handle back navigation from RUDataSection to RUList
     * Clears stale RU data to prevent flash of old content when selecting a new RU
     * Retains cached RU list data without making new API calls
     */
    handleBackFromRUData() {
      this.viewTransitionDirection = 'back';
      // Clear stale RU detail data to prevent flash when clicking a new RU
      this.commentarydata = [];
      this.commentarycycledata = {};
      this.commentaryrudata = {};
      this.isReportingUnitClicked = false;
      // Reset selectedreportingunit to 'all' when navigating back
      this.selectedreportingunit = 'all';
      
      // Reset view options when navigating back
      this.cycletypeReadview = 'Proforma';
      this.isCommentaryView = false;
      this.toggletableview = 0; // Reset list view to "List" (0)

      // Reset selectedReportingUnitType in reportingUnitFilter to 'all' before restoring filter state
      if (this.reportingUnitFilter) {
        this.reportingUnitFilter.selectedReportingUnitType = 'all';
        this.reportingUnitFilter.selectedreportingunit = 'all';
      }
      // Pass skipReload=false to force filter re-application and data loading
      // This fixes the issue where data wasn't showing after navigation from breadcrumbs
      this.setRportingUnitFilter(false);
    },
    /**
     * Handle statement type change from RUDataSection tabs
     * Sets reportingType and reloads data with updated filter
     * @param {String} statementType - 'balance_sheet' or 'profit_loss'
     */
    handleStatementTypeChange(statementType) {
      // Set reportingType: 'bs' for Balance Sheet, empty for P&L
      this.reportingType = statementType === 'balance_sheet' ? 'bs' : '';
      // Reload data with new filter
      this.loadData(true);
    },
    /**
     * Get status label from labels configuration
     * Used by Breadcrumbs component for status display
     * @param {String} key - The label key
     * @param {String} fallback - Fallback text if key not found
     * @returns {String} The status label
     */
    getStatusLabel(key, fallback) {
      if (this.$nova && typeof this.$nova.labelsName === 'function') {
        return this.$nova.labelsName('cycle_page', key, fallback);
      }
      return fallback;
    },
    /**
     * Reset all filters through the filter widget when downstream views request it.
     */
    handleResetFilters() {
      this.isReportingUnitClicked = false;
      this.selectedreportingunit = 'all';
      this.$refs.childfilter?.setValue('reload', true);
    },
    // Guard to prevent duplicate API calls
    async refreshData() {
      if (this.isReportingUnitdataloading) return;
      this.isReportingUnitdataloading = true;
      try {
        if (typeof helpers.refreshData === 'function') {
          await helpers.refreshData.call(this);
        }
      } finally {
        this.isReportingUnitdataloading = false;
      }
    },
    /**
     * Handle reporting unit fetch requests coming from list components.
     * @param {{loadMore?: boolean, page?: number}|boolean|undefined} payload
     */
    handleReportingUnitRequest(payload) {
      const normalizedPayload = typeof payload === 'object' && payload !== null ? payload : {};
      const maintainFilters = normalizedPayload.maintainFilters === true;
      
      // Create tableFilters excluding pagination/control keys
      const tableFilters = { ...normalizedPayload };
      delete tableFilters.page;
      delete tableFilters.limit;
      delete tableFilters.loadMore;
      delete tableFilters.clearTableFilters;
      delete tableFilters.maintainFilters;
      
      // Calculate reload BEFORE updating state
      const currentFilters = this.tableApiFilters || {};
      // If we have filters coming in, compare them. If explicitly clearing, it's a change/reload.
      const filtersChanged = Object.keys(tableFilters).length > 0 && JSON.stringify(tableFilters) !== JSON.stringify(currentFilters);
      const isClearRequest = !!normalizedPayload.clearTableFilters;
      const shouldReload = filtersChanged || isClearRequest;

      // Update tableApiFilters logic:
      if (Object.keys(tableFilters).length > 0) {
        this.tableApiFilters = tableFilters;
      } else if (isClearRequest && !maintainFilters) {
        // Explicit clear request from List.vue
        this.tableApiFilters = {};
      }
      // Note: We no longer auto-clear on page 1 request to prevent accidental clearing during pagination resets

      const pageRequested = Object.prototype.hasOwnProperty.call(normalizedPayload, 'page')
        ? Number(normalizedPayload.page)
        : null;
      const limitRequested = Object.prototype.hasOwnProperty.call(normalizedPayload, 'limit')
        ? Number(normalizedPayload.limit)
        : null;

      // If maintaining filters and filters haven't changed, force a reload to ensure we fetch with current filters
      // This handles the "No Data" case where we want to refresh but keep filters applied
      const forceReload = shouldReload || (maintainFilters && Object.keys(this.tableApiFilters || {}).length > 0);

      if (Number.isInteger(pageRequested) && pageRequested > 0) {
        this.reportingUnitsCurrentPage = pageRequested;
        // For page navigation: reload=shouldReload, loadMore=false, pageIndex=pageRequested-1 (0-based)
        const nextPerPage = limitRequested && limitRequested > 0 ? limitRequested : this.pageSize;
        if (nextPerPage !== this.pageSize) {
          this.pageSize = nextPerPage;
        }
        
        // This ensures filter parameters populate the API call for pagination/sorting updates
        this.loadReportingUnit(forceReload, false, pageRequested - 1, this.tableApiFilters);
        return;
      }

      const loadMoreRequested = Object.prototype.hasOwnProperty.call(normalizedPayload, 'loadMore')
        ? Boolean(normalizedPayload.loadMore)
        : Boolean(payload);
      if (loadMoreRequested && !this.hasMoreReportingUnits && !forceReload) {
        return;
      }
      this.loadReportingUnit(forceReload, loadMoreRequested, null, this.tableApiFilters);
    },
    handleOpenNetSalesUpload() {
      this.uploadnetsalescommentarydialog = true;
      this.uploadfiledata_netsales = [];
    },
    handleOpenRevenueUpload() {
      this.uploadrevenuecommentarydialog = true;
      this.uploadfiledata_revenue = [];
    },
    normalizeCommentaryText(value) {
      return String(value ?? '').trim();
    },
    captureCommentaryBaselines() {
      const commentary = this.selectedcommentary || {};
      this.commentaryBaselines = {
        commentary1: this.normalizeCommentaryText(commentary.commentary1),
        commentary2: this.normalizeCommentaryText(commentary.commentary2),
        approvereason: this.normalizeCommentaryText(commentary.approvereason),
        regionalcommentary1: this.normalizeCommentaryText(commentary.regionalcommentary1),
        regionalcommentary2: this.normalizeCommentaryText(commentary.regionalcommentary2),
        regionalapprovereason: this.normalizeCommentaryText(commentary.regionalapprovereason),
      };
      this.commentaryBaselinesReady = true;
    },
    updateCommentaryBaseline(field, value) {
      if (!field || !Object.prototype.hasOwnProperty.call(this.commentaryBaselines, field)) {
        return;
      }
      this.$set(this.commentaryBaselines, field, this.normalizeCommentaryText(value));
    },
    validateInlineSaveText(value) {
      if (!this.normalizeCommentaryText(value)) {
        this.$store.commit('sbError', 'Please enter valid text before saving.');
        return false;
      }
      return true;
    },
    async saveCommentary(field) {
      if (!field) {
        return helpers.saveCommentary.call(this);
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for saving commentary.');
        return;
      }

      const isBulk = this.bulksubmit;
      const targetId = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
      if (!targetId) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_ERROR);
        return;
      }

      if (field === 'proforma' && !this.validateInlineSaveText(this.selectedcommentary?.commentary1)) {
        return;
      }
      if (field === 'forecast' && !this.validateInlineSaveText(this.selectedcommentary?.commentary2)) {
        return;
      }

      const isShortOnly = (text) => text && String(text).trim().length > 0 && String(text).trim().length < 15;

      if (this.ispreparer && field === 'proforma' && isShortOnly(this.selectedcommentary?.commentary1)) {
        this.$store.commit('sbError', `${this.proforma_shortform_label} commentary too short (min 15 chars).`);
        return;
      }
      if (this.ispreparer && field === 'forecast' && isShortOnly(this.selectedcommentary?.commentary2)) {
        this.$store.commit('sbError', `${this.forcast_shortform_label} commentary too short (min 15 chars).`);
        return;
      }

      this.commentaryloading = true;
      this.saveLoading = true;
      this.saveLocalCommentaryField = field;

      try {
        const baseUrl = isBulk
          ? SL_COMMENTARY.ENDPOINTS.SAVE_BULK
          : `${SL_COMMENTARY.ENDPOINTS.SAVE_SINGLE}/${targetId}`;

        const thresholdcross = this.ispreparer ? {
          crosscontrolthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma,
          crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast,
          crossmanagementthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma,
          crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast,
        } : {};

        const filter = {
          save: true,
          cycletype: this.cycletype,
          all: this.bulkcommentall,
          replace: this.bulkcommentreplace,
          reportingunit: this.commentaryrudata?._id,
        };
        if (this.reportingType) {
          filter.reporting_type = this.reportingType;
        }
        if (field === 'proforma' || field === 'forecast') {
          filter.commentaryField = field;
        }

        const body = {
          id: targetId,
          filter: {
            ...filter,
            ...thresholdcross,
          },
          data: {
            commentary1: String(this.selectedcommentary?.commentary1 ?? '').trim(),
            commentary2: String(this.selectedcommentary?.commentary2 ?? '').trim(),
            summarycommentary1: String(this.summaryAiProforma ?? '').trim(),
            summarycommentary2: String(this.summaryAiForecast ?? '').trim(),
          },
        };

        const success = await this.saveSlCommentaryAction({
          axios: axiosInstance,
          url: baseUrl,
          body,
        });

        if (success && this.selectedcommentary && !isBulk) {
          const savedValue1 = String(this.selectedcommentary.commentary1 ?? '').trim();
          const savedValue2 = String(this.selectedcommentary.commentary2 ?? '').trim();
          this.selectedcommentary.savedcommentary1 = savedValue1;
          this.selectedcommentary.savedcommentary2 = savedValue2;
          if (this.selectedcommentary.__key !== undefined && this.commentarydata[this.selectedcommentary.__key]) {
            this.commentarydata[this.selectedcommentary.__key].savedcommentary1 = savedValue1;
            this.commentarydata[this.selectedcommentary.__key].savedcommentary2 = savedValue2;
          }
          this.updateCommentaryBaseline('commentary1', savedValue1);
          this.updateCommentaryBaseline('commentary2', savedValue2);
        } else if (success && isBulk) {
          this.loadContent(true);
        }
      } catch (error) {
        console.error('[Base]: saveCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveLocalCommentaryField = '';
      }
    },
    async saveRegionalCommentary(field) {
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for saving regional commentary.');
        return;
      }

      const targetId = this.selectedcommentary?._id;
      if (!targetId) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_ERROR);
        return;
      }

      if (field === 'proforma' && !this.validateInlineSaveText(this.selectedcommentary?.regionalcommentary1)) {
        return;
      }
      if (field === 'forecast' && !this.validateInlineSaveText(this.selectedcommentary?.regionalcommentary2)) {
        return;
      }

      const isShortOnly = (text) => text && String(text).trim().length > 0 && String(text).trim().length < 15;

      if (field === 'proforma' && isShortOnly(this.selectedcommentary?.regionalcommentary1)) {
        this.$store.commit('sbError', `${this.proforma_shortform_label} regional commentary too short (min 15 chars).`);
        return;
      }
      if (field === 'forecast' && isShortOnly(this.selectedcommentary?.regionalcommentary2)) {
        this.$store.commit('sbError', `${this.forcast_shortform_label} regional commentary too short (min 15 chars).`);
        return;
      }

      this.commentaryloading = true;
      this.saveLoading = true;
      this.saveRegionalCommentaryField = field;

      try {
        const filter = {
          save: true,
          saveType: 'regional_commentary',
          commentaryField: field,
          cycletype: this.cycletype,
          reportingunit: this.commentaryrudata?._id,
          reporting_type: this.reportingType || 'pl',
        };

        const data = {};
        if (field === 'proforma') {
          data.regionalcommentary1 = String(this.selectedcommentary?.regionalcommentary1 ?? '').trim();
        } else if (field === 'forecast') {
          data.regionalcommentary2 = String(this.selectedcommentary?.regionalcommentary2 ?? '').trim();
        }

        const body = {
          id: targetId,
          filter,
          data,
        };

        const success = await this.saveSlCommentaryAction({
          axios: axiosInstance,
          url: `${SL_COMMENTARY.ENDPOINTS.SAVE_SINGLE}/${targetId}`,
          body,
        });

        if (success && this.selectedcommentary) {
          if (field === 'proforma') {
            const savedValue = String(this.selectedcommentary.regionalcommentary1 ?? '').trim();
            this.selectedcommentary.savedregionalcommentary1 = savedValue;
            this.updateCommentaryBaseline('regionalcommentary1', savedValue);
          } else if (field === 'forecast') {
            const savedValue = String(this.selectedcommentary.regionalcommentary2 ?? '').trim();
            this.selectedcommentary.savedregionalcommentary2 = savedValue;
            this.updateCommentaryBaseline('regionalcommentary2', savedValue);
          }
        }
      } catch (error) {
        console.error('[Base]: saveRegionalCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveRegionalCommentaryField = '';
      }
    },
    async saveLocalApprovalReason() {
      const reason = this.normalizeCommentaryText(this.selectedcommentary?.approvereason);
      if (!reason) {
        this.$store.commit('sbError', 'Please enter valid text before saving.');
        return;
      }

      const targetId = this.selectedcommentary?._id;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!targetId || !axiosInstance) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR);
        return;
      }

      this.saveLocalReasonLoading = true;
      try {
        const body = {
          id: targetId,
          filter: {
            saveType: 'local_reason',
            cycletype: this.cycletype,
            reportingunit: this.commentaryrudata?._id,
            reporting_type: this.reportingType || 'pl',
          },
          data: [{ approvereason: reason }],
        };

        const success = await this.saveRegionalApprovalReasonAction({
          axios: axiosInstance,
          url: `${SL_COMMENTARY.ENDPOINTS.SAVE_APPROVAL_REASON}/${targetId}`,
          body,
        });

        if (success) {
          this.selectedcommentary.savedreason = reason;
          this.updateCommentaryBaseline('approvereason', reason);
        }
      } catch (error) {
        console.error('[Base]: saveLocalApprovalReason failed', error);
      } finally {
        this.saveLocalReasonLoading = false;
      }
    },
    async saveRegionalApprovalReason() {
      const reason = this.normalizeCommentaryText(this.selectedcommentary?.regionalapprovereason);
      if (!reason) {
        this.$store.commit('sbError', 'Please enter valid text before saving.');
        return;
      }

      const targetId = this.selectedcommentary?._id;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!targetId || !axiosInstance) {
        this.$store.commit('sbError', SL_COMMENTARY.MESSAGES.SAVE_REASON_ERROR);
        return;
      }

      this.saveRegionalReasonLoading = true;
      try {
        const body = {
          id: targetId,
          filter: {
            saveType: 'regional_reason',
            cycletype: this.cycletype,
            reportingunit: this.commentaryrudata?._id,
            reporting_type: this.reportingType || 'pl',
          },
          data: [{ regionalapprovereason: reason }],
        };

        const success = await this.saveRegionalApprovalReasonAction({
          axios: axiosInstance,
          url: `${SL_COMMENTARY.ENDPOINTS.SAVE_APPROVAL_REASON}/${targetId}`,
          body,
        });

        if (success) {
          this.selectedcommentary.savedregionalreason = reason;
          this.updateCommentaryBaseline('regionalapprovereason', reason);
        }
      } catch (error) {
        console.error('[Base]: saveRegionalApprovalReason failed', error);
      } finally {
        this.saveRegionalReasonLoading = false;
      }
    },
  },
  computed: {
    // Reject target options for regional approvers (localized)
    rejectTargetList() {
      return helpers.getRejectTargetList(this.workflows, this.$nova.labelsName);
    },
    /**
     * possibleRoles from getaccesshierarchy (stored in Actual/Forecast hierarchy).
     * Used by RUList User Role column filter — must match API, not hardcoded extras.
     */
    accessHierarchyPossibleRoles() {
      const storeState =
        this.$store.state[this.appname] ||
        this.$store.state.m_varianceanalysis ||
        this.$store.state.varianceanalysis ||
        {};
      const hierarchyData =
        this.cycletype === 'Forecast'
          ? storeState.forecasthierarchydata || {}
          : storeState.actualhierarchydata || {};
      const rawRoles =
        hierarchyData.possibleroles ||
        hierarchyData.possibleRoles ||
        hierarchyData.rolelist ||
        [];
      return Array.isArray(rawRoles) ? rawRoles : [];
    },
    // Computed property for back button visibility (avoiding optional chaining in template)
    showBackButton() {
      const storeState = this.$store.state[this.appname] || this.$store.state.varianceanalysis;
      if (!storeState) return false;
      
      if (this.cycletype === 'Actual') {
        return storeState.actualFilterStatus && storeState.actualFilterStatus.length !== 1;
      } else if (this.cycletype === 'Forecast') {
        return storeState.forecastFilterStatus && storeState.forecastFilterStatus.length !== 1;
      }
      return false;
    },
    /**
     * Computed property to determine if breadcrumb should be shown in CycleHeader
     * Shows breadcrumb when RU Data Section view is active
     * @returns {Boolean} Whether to display the breadcrumb
     */
    showCycleBreadcrumb() {
      return (this.selectedreportingunit !== 'all' && this.selectedreportingunit) || 
             (this.toggleview === 0 && this.isReportingUnitClicked) || 
             this.toggleview === 3;
    },
    viewTransitionName() {
      return this.viewTransitionDirection === 'back' ? 'ru-view-back' : 'ru-view-forward';
    },
    /**
     * Computed property to generate breadcrumb text for CycleHeader
     * Format: "RU code - Reportingunit name"
     * @returns {String} Breadcrumb text or empty string
     */
    cycleBreadcrumbText() {
      if (!this.showCycleBreadcrumb) {
        return '';
      }
      // Try to get RU info from commentarycycledata (API response)
      if (this.commentarycycledata && this.commentarycycledata.reportingunit_detail) {
        const ru = this.commentarycycledata.reportingunit_detail;
        const code = ru.code || '';
        const name = ru.name || '';
        if (code || name) {
          return code && name ? `${code} - ${name}` : (code || name);
        }
      }
      // Fallback to commentaryrudata if available
      if (this.commentaryrudata && (this.commentaryrudata.code || this.commentaryrudata.name)) {
        const code = this.commentaryrudata.code || '';
        const name = this.commentaryrudata.name || '';
        return code && name ? `${code} - ${name}` : (code || name);
      }
      // Fallback: Try to get RU info from reportingunitdata based on selectedreportingunit
      // This provides immediate display when navigating between RUs before API responds
      if (this.selectedreportingunit && this.reportingunitdata && this.reportingunitdata.length > 0) {
        const selectedRU = this.reportingunitdata.find(ru => {
          const ruId = ru.reportingunit_detail?._id || ru.reportingunit || ru._id;
          return ruId === this.selectedreportingunit;
        });
        if (selectedRU && selectedRU.reportingunit_detail) {
          const code = selectedRU.reportingunit_detail.code || '';
          const name = selectedRU.reportingunit_detail.name || '';
          if (code || name) {
            return code && name ? `${code} - ${name}` : (code || name);
          }
        }
      }
      return '';
    },
    /**
     * Computed property for breadcrumb cycle label (first clickable text)
     * Returns "Actual Cycle" or "Forecast Cycle" based on cycletype
     * @returns {String} Cycle label text
     */
    breadcrumbCycleLabel() {
      return this.cycletype === 'Actual' 
        ? this.$nova.labelsName('cycle_page', 'variance_analysis_label', 'Actual Cycle')
        : this.$nova.labelsName('cycle_page', 'forecast_cycle_label', 'Forecast Cycle');
    },
    /**
     * Computed property for breadcrumb active commentary object
     * Used to display status in breadcrumb (requires __stage property)
     * @returns {Object} Commentary object with __stage or empty object
     */
    breadcrumbActiveCommentary() {
      // Return an object with __stage from commentarycycledata if available
      if (this.commentarycycledata && typeof this.commentarycycledata.stage === 'number') {
        return { __stage: this.commentarycycledata.stage };
      }
      // Return empty object if no stage available (status won't be shown)
      return {};
    },
    // Filter state from store (persists on navigation)
    selectedfilter: {
      get() {
        return this.$store.state.varianceanalysis.baseSelectedFilter || [0, 1, -1, 5, 6, -2, 7, 4, 3, 9];
      },
      set(value) {
        this.$store.commit('varianceanalysis/setBaseSelectedFilter', value);
      },
    },
    pagedItems() {
      return this.visibleItems.slice(this.startIndex, this.endIndex + 1);
    },
    visibleItems() {
      let [res, expandedIds, isFilterSet] = this.filteredcommentarydataRaw();
      if (isFilterSet) {
        let index = 0;
        return res.map((item) => {
          item.__index = index++;
          return item;
        });
      } else {
        let index = 0;
        return res.filter(item => expandedIds.includes(item.__code) || this.expandedIds.has(item.__code)).map((item) => {
          item.__index = index++;
          return item;
        });
      }
    },
    isSpecialRu(){
    return this.reportingUnitType === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.RU_TYPE.GROUP_M || this.reportingUnitType === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.RU_TYPE.SOXID;
    },

    filteredcommentarydata() {
      let res = this.filteredcommentarydataRaw();
      return res[0];
    },
    ungroupedItems() {
      if (!this.filteredcommentarydata || !this.filteredcommentarydata.length) return [];
      return this.filteredcommentarydata.filter(item => (item.__parent === 'NA' || item?.glcode_detail?.path?.includes('NA')) && item.__code !== 'NA');
    },
    previewBulkDialogWidth() {
      return Object.keys(this.bulksubmitfiledata || {}).length > 0 ? '800' : '400';
    },
    isBulkSubmitDisabled() {
      return this.ispreparer && !this.workflows.lcp && !this.workflows.lmp && !this.workflows.lcf && !this.workflows.lmf;
    },
    bulkApproveLocalItems() {
      const data = this.bulkapprovelocalfiledata;
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === 'object') {
        return Object.keys(data).map(key => ({
          __key: key,
          ...(data[key] || {}),
        }));
      }
      return [];
    },
    /**
     * Computed property to get eligible reporting units for email reminder dialog
     * Maps selectedlocalapproval cycle IDs to full RU data with status info
     * Filters out RUs that are not eligible for email reminders based on:
     * - showMailReminderButton must be true (user is local/regional approver with pending items)
     * - Must NOT be ready for local RU level approval
     * - Must NOT be ready for regional RU level approval
     * @returns {Array} List of eligible RUs with cycleId, code, name, l1Status, l1StatusLabel, l2Status, l2StatusLabel, userRole
     */
    eligibleReportingUnitsForEmailReminder() {
      const cycleIds = this.selectedlocalapproval || [];
      if (!cycleIds.length || !this.reportingunitdata || !this.reportingunitdata.length) {
        return [];
      }
      
      return cycleIds.map(cycleId => {
        // Find the RU data matching this cycle ID
        const ruData = this.reportingunitdata.find(ru => {
          const ruCycleId = ru.cycle_detail?._id || ru.cycle || ru._id;
          return ruCycleId === cycleId;
        });
        
        if (!ruData) return null;
        
        // Filter: Check if RU is eligible for email reminder
        // Must have showMailReminderButton flag set to true
        // Must NOT be ready for local or regional RU level approval
        const showMailReminderButton = ruData.showMailReminderButton === true;
        const isReadyForLocalApproval = ruData.isReadyForLocalRuLevelApproval === true;
        const isReadyForRegionalApproval = ruData.isReadyForRegionalRuLevelApproval === true;
        
        // Skip RUs that don't meet the email reminder eligibility criteria
        if (!showMailReminderButton || isReadyForLocalApproval || isReadyForRegionalApproval) {
          return null;
        }
        
        const cycleDetail = ruData.cycle_detail || {};
        const ruDetail = ruData.reportingunit_detail || {};
        
        // Get L1 (local) status
        const l1Status = cycleDetail.localRuLevelApprovalStatus ?? 
                        ruData.localRuLevelApprovalStatus ?? 
                        cycleDetail.local_ru_approve ?? 
                        ruData.local_ru_approve ?? 0;
        
        // Get L2 (regional) status  
        const l2Status = cycleDetail.regionalRuLevelApprovalStatus ?? 
                        ruData.regionalRuLevelApprovalStatus ?? 
                        cycleDetail.regional_ru_approve ?? 
                        ruData.regional_ru_approve ?? 0;
        
        // Get user role - same rules as List.vue getUserRole / userHasMultipleRoles
        let userRole = 'View Only';
        const roleCount =
          Number(!!ruDetail.submitter?.includes(this.userid)) +
          Number(!!ruDetail.approver?.includes(this.userid)) +
          Number(!!ruDetail.regional_approver?.includes(this.userid)) +
          Number(!!ruDetail.manager?.includes(this.userid));
        if (roleCount > 1) {
          userRole = 'Multiple Roles';
        } else if (ruDetail.submitter?.includes(this.userid)) {
          userRole = this.$nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer');
        } else if (ruDetail.approver?.includes(this.userid)) {
          userRole = this.$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver');
        } else if (ruDetail.regional_approver?.includes(this.userid)) {
          userRole = this.$nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver');
        } else if (ruDetail.manager?.includes(this.userid)) {
          userRole = 'Manager';
        }
        
        // Get status labels
        const l1StatusLabel = this.getStatusLabelByCode(l1Status);
        const l2StatusLabel = this.getStatusLabelByCode(l2Status);
        
        return {
          cycleId,
          code: ruDetail.code || '',
          name: ruDetail.name || '',
          l1Status,
          l1StatusLabel,
          l2Status,
          l2StatusLabel,
          userRole,
        };
      }).filter(Boolean); // Remove null entries (non-matching or ineligible RUs)
    },
    /**
     * Computed property to get eligible reporting units for RU approval dialog
     * Maps selectedlocalapproval or selectedregionalapproval cycle IDs to full RU data based on ruapprovaltype
     * Filters out RUs that are not eligible for approval based on:
     * - For local approval: isReadyForLocalRuLevelApproval must be true AND user must be in approver array
     * - For regional approval: isReadyForRegionalRuLevelApproval must be true AND user must be in regional_approver array
     * @returns {Array} List of eligible RUs with cycleId, code, name, l1Status, l1StatusLabel, l2Status, l2StatusLabel, userRole
     */
    eligibleReportingUnitsForApproval() {
      // Determine which cycle IDs to use based on approval type
      const cycleIds = this.ruapprovaltype === 'regional' 
        ? (this.selectedregionalapproval || [])
        : (this.selectedlocalapproval || []);
      
      if (!cycleIds.length || !this.reportingunitdata || !this.reportingunitdata.length) {
        return [];
      }
      
      return cycleIds.map(cycleId => {
        // Find the RU data matching this cycle ID
        const ruData = this.reportingunitdata.find(ru => {
          const ruCycleId = ru.cycle_detail?._id || ru.cycle || ru._id;
          return ruCycleId === cycleId;
        });
        
        if (!ruData) return null;
        
        const cycleDetail = ruData.cycle_detail || {};
        const ruDetail = ruData.reportingunit_detail || {};
        
        // Filter: Check if RU is eligible for approval based on approval type
        if (this.ruapprovaltype === 'regional') {
          // For regional approval: isReadyForRegionalRuLevelApproval must be true AND user must be in regional_approver array
          const isReadyForRegional = cycleDetail.isReadyForRegionalRuLevelApproval === true || 
                                     ruData.isReadyForRegionalRuLevelApproval === true;
          const regionalApprovers = Array.isArray(ruDetail.regional_approver) ? ruDetail.regional_approver : [];
          const isUserRegionalApprover = regionalApprovers.includes(this.userid);
          
          if (!isReadyForRegional || !isUserRegionalApprover) {
            return null;
          }
        } else {
          // For local approval: isReadyForLocalRuLevelApproval must be true AND user must be in approver array (matches List.vue shouldShowLocalApprovalIcon.)
          const isReadyForLocal = cycleDetail.isReadyForLocalRuLevelApproval === true || 
                                  ruData.isReadyForLocalRuLevelApproval === true;
          const localApprovers = Array.isArray(ruDetail.approver) ? ruDetail.approver : [];
          const isUserLocalApprover = localApprovers.includes(this.userid);
          
          if (!isReadyForLocal || !isUserLocalApprover) {
            return null;
          }
        }
        
        // Get L1 (local) status
        const l1Status = cycleDetail.localRuLevelApprovalStatus ?? 
                        ruData.localRuLevelApprovalStatus ?? 
                        cycleDetail.local_ru_approve ?? 
                        ruData.local_ru_approve ?? 0;
        
        // Get L2 (regional) status  
        const l2Status = cycleDetail.regionalRuLevelApprovalStatus ?? 
                        ruData.regionalRuLevelApprovalStatus ?? 
                        cycleDetail.regional_ru_approve ?? 
                        ruData.regional_ru_approve ?? 0;
        
        // Get user role - same rules as List.vue getUserRole / userHasMultipleRoles
        let userRole = 'View Only';
        const roleCount =
          Number(!!ruDetail.submitter?.includes(this.userid)) +
          Number(!!ruDetail.approver?.includes(this.userid)) +
          Number(!!ruDetail.regional_approver?.includes(this.userid)) +
          Number(!!ruDetail.manager?.includes(this.userid));
        if (roleCount > 1) {
          userRole = 'Multiple Roles';
        } else if (ruDetail.submitter?.includes(this.userid)) {
          userRole = this.$nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer');
        } else if (ruDetail.approver?.includes(this.userid)) {
          userRole = this.$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver');
        } else if (ruDetail.regional_approver?.includes(this.userid)) {
          userRole = this.$nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver');
        } else if (ruDetail.manager?.includes(this.userid)) {
          userRole = 'Manager';
        }
        
        // Get status labels
        const l1StatusLabel = this.getStatusLabelByCode(l1Status);
        const l2StatusLabel = this.getStatusLabelByCode(l2Status);
        
        return {
          cycleId,
          code: ruDetail.code || '',
          name: ruDetail.name || '',
          l1Status,
          l1StatusLabel,
          l2Status,
          l2StatusLabel,
          userRole,
        };
      }).filter(Boolean); // Remove null entries (non-matching or ineligible RUs)
    },
    /**
     * Dynamic label for Actual based on reportingType
     * Returns balance sheet specific label when reportingType is 'bs', otherwise default
     */
    actual_label() {
      return this.reportingType === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reportingType
     * Returns balance sheet specific label when reportingType is 'bs', otherwise default
     */
    proforma_shortform_label() {
      return this.reportingType === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reportingType
     * Returns balance sheet specific label when reportingType is 'bs', otherwise default
     */
    forcast_shortform_label() {
      return this.reportingType === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
  },
  watch: {
    commantorydialog(val) {
      if (!val) {
        this.commentaryBaselinesReady = false;
        this.requestcommentarylocalcontrolvsProforma = false
        this.requestcommentarylocalcontrolvsForecast = false
        this.requestcommentarylocalmanagementvsProforma = false
        this.requestcommentarylocalmanagementvsForecast = false
        this.requestcommentarylocalcontrol = false;
        this.requestcommentarylocalmanagement = false;
        this.requestcommentaryregionalcontrol = false;
        this.requestcommentaryregionalmanagement = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
      }
    },
    visibleItems(newItems, oldItems) {
      // Only reset pagination when the underlying data source changes significantly
      // (e.g., new filter applied, new data load, etc.)
      // Do NOT reset when just expanding/collapsing rows
      
      const [, , isFilterSet] = this.filteredcommentarydataRaw();
      const desiredEndIndex = Math.max(this.perpage - 1, 0);

      // Update isFilterSet state
      if (this.isFilterSet !== isFilterSet) {
        this.isFilterSet = isFilterSet;
      }
      
      // Check if this is an expand/collapse operation by comparing lengths
      // If items were added/removed due to expansion, don't reset - extend endIndex if needed
      const oldLength = oldItems ? oldItems.length : 0;
      const newLength = newItems ? newItems.length : 0;
      const isExpansionChange = oldLength > 0 && newLength > 0;
      
      if (isExpansionChange) {
        // This is likely an expand/collapse - preserve scroll position
        // If new items were added (expansion), extend endIndex to include them if visible
        if (newLength > oldLength && this.endIndex < newLength) {
          // Items added - extend endIndex to show new children
          const itemsAdded = newLength - oldLength;
          this.endIndex = Math.min(this.endIndex + itemsAdded, newLength);
        } else if (newLength < oldLength) {
          // Items removed (collapse) - adjust endIndex if it exceeds new length
          this.endIndex = Math.min(this.endIndex, Math.max(newLength - 1, desiredEndIndex));
        }
        // Keep startIndex at 0 (our new strategy)
      } else {
        // This is a fresh data load or significant change - reset pagination
        if (this.startIndex !== 0) {
          this.startIndex = 0;
        }
        if (this.endIndex !== desiredEndIndex) {
          this.endIndex = desiredEndIndex;
        }
      }
    },
    filteredcommentarydata() {
      this.isAllExpanded = false;
    },
    "customfilterstoggle": function (v) {
      localStorage.setItem("commentary_custom_filter_toggle", v)
    },
    allRUDownloadYear() {
      this.downloadperiodlist = [];
      this.allRUDownloadPeriod = "";
      (this.$refs.childfilter?.hierarchyData?.periodlist || []).filter((item) => item.year === this.allRUDownloadYear)
        .forEach((item) => {
          this.downloadperiodlist.push({ name: item?.month || '', _id: item?._id || '', number: item?.number || 0 })
        });
      this.downloadperiodlist = Array.from(this.downloadperiodlist.sort((a, b) => a.number - b.number));
      this.allRUDownloadPeriod = this.downloadperiodlist[0]?._id || "";
    },
    // CHANGE: if user switches role in dropdown, re-apply flags
    selectedRuRole(newRole) {
      if (newRole) {
        this.applyRoleFlags(newRole);
      }
    },
  },
  beforeDestroy() {
    // Cleanup lazy loading scroll listeners
    this.cleanupLazyLoading();
    
    // Save page state to store when component is destroyed (navigating away)
    // This allows restoring state when navigating back from GLBreakdown
    const pageState = {
      commentarydata: this.commentarydata,
      commentarydatajson: this.commentarydatajson,
      commentarydatajsonById: this.commentarydatajsonById,
      commentarydatajsonByGLCode: this.commentarydatajsonByGLCode,
      commentaryrudata: this.commentaryrudata,
      commentarycycledata: this.commentarycycledata,
      commentarysummarydata: this.commentarysummarydata,
      commentarylocalsummarydata: this.commentarylocalsummarydata,
      commentaryregionalsummarydata: this.commentaryregionalsummarydata,
      hierarchyData: this.hierarchyData,
      selectedrole: this.selectedrole,
      selectedyear: this.selectedyear,
      selectedperiod: this.selectedperiod,
      selectednetwork: this.selectednetwork,
      selectedregion: this.selectedregion,
      selectedcountry: this.selectedcountry,
      selectedreportingunit: this.selectedreportingunit,
      toggleview: this.toggleview,
      toggletableview: this.toggletableview,
      ispreparer: this.ispreparer,
      isapprover: this.isapprover,
      isregionalapprover: this.isregionalapprover,
      ismanager: this.ismanager,
      isviewonly: this.isviewonly,
      cyclestage: this.cyclestage,
      customfilter: this.customfilter,
      customfilterstoggle: this.customfilterstoggle,
      ispendinglocalruapproval: this.ispendinglocalruapproval,
      ispendingregionalruapproval: this.ispendingregionalruapproval,
      gllist: this.gllist,
      tablecolors: this.tablecolors,
      period: this.period,
      perioddata: this.perioddata,
      periodlist: this.periodlist,
      network: this.network,
      networkdata: this.networkdata,
      networklist: this.networklist,
      region: this.region,
      regiondata: this.regiondata,
      regionlist: this.regionlist,
      country: this.country,
      countrydata: this.countrydata,
      reportingunit: this.reportingunit,
      reportingunitdata: this.reportingunitdata,
      reportingunitlist: this.reportingunitlist,
      
      // Save cache data
      commentarydataList: this.commentarydataList,
      filterData: this.filterData,
      periodDataList: this.periodDataList,
      networkList: this.networkList,
      regionList: this.regionList,
      countrylist: this.countrylist,

      // Role-related state for SOD
      isSodEnabled: this.isSodEnabled,
      ruRoleOptions: this.ruRoleOptions,
      selectedRuRole: this.selectedRuRole,
      // Regional Commentary Automation state
      isRegionalCommentaryAutomationEnabled: this.isRegionalCommentaryAutomationEnabled,
      // Bulk submit columns for Excel download
      bulksubmitcolumns: this.bulksubmitcolumns,
      // Workflow state
      workflows: this.workflows,
      workflowtext: this.workflowtext,
      // RU approval state
      islocalapproverinru: this.islocalapproverinru,
      isregionalapproverinru: this.isregionalapproverinru,
      // View state
      isReportingUnitClicked: this.isReportingUnitClicked,
      // Reporting type for statement tab filtering
      reportingType: this.reportingType,
      // View options toolbar state
      isCommentaryView: this.isCommentaryView,
      cycletypeReadview: this.cycletypeReadview,
    };
    this.$store.commit('varianceanalysis/setBasePageState', pageState);
    
    // Cancel any pending getreportingunitdata request when navigating away
    if (this.loadDataAbortController) {
      this.loadDataAbortController.abort();
      this.loadDataAbortController = null;
    }
  }
}
</script>

<style scoped>
/* Filter toolbar layout - prevents alignment shifts */
.filter-toolbar-container {
  display: flex;
  align-items: center;
  width: 100%;
}

/* Back button container - fixed width for consistent layout */
.back-btn-container {
  /* min-width: 50px;
  width: 50px; */
  flex-shrink: 0;
  display: flex;
  /* align-items: center;
  justify-content: flex-start; */
}

/* Filter wrapper - takes remaining space and centers content */
.filter-wrapper {
  /* flex: 1; */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Sync button container - fixed width for consistent layout */
.sync-btn-container {
  min-width: 120px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.scrollable-card-text {
  max-height: 200px;
  /* Adjust the maximum height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

.icon {
  margin-right: 8px;
}

.rotate {
  animation: spin 1s linear infinite;
}

.color-box {
  width: 100px;
  height: 100px;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.chip-container {
  display: flex;
  flex-wrap: wrap;
  /* This ensures that the chips wrap when there's no space */
}
.node-container {
  height: 50px;
  margin-right: 5px;
}
.node-container-read{
  height: 90px;
  margin-right: 5px;
}
.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block; /* Important for visibility */
  height: 100%; /* Make sure it stretches */
  content: "";
}

.padding-level-0 { padding-left: 0px; }
.padding-level-1 { padding-left: 10px; }
.padding-level-2 { padding-left: 20px; }
.padding-level-3 { padding-left: 30px; }
.padding-level-4 { padding-left: 40px; }
.padding-level-5 { padding-left: 50px; }
.padding-level-6 { padding-left: 60px; }
.padding-level-7 { padding-left: 70px; }
.padding-level-8 { padding-left: 80px; }

.v-table-color{
  margin-bottom: 50px;
}
td.description-cell {
    width: 15% !important;
}

.node-container {
  height: 50px;
  margin-right: 5px;
}

.node-container-read {
  height: 90px;
  margin-right: 5px;
}

.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block;
  /* Important for visibility */
  height: 100%;
  /* Make sure it stretches */
  content: "";
}

.childlevele {
  width: 0.5px;
  background-color: var(--color-hierarchy-border);

}

.v-table-color {
  margin-bottom: 50px;
}

/* td.description-cell {
  width: 15% !important;
} */


.parent-row {
  background-color: #e6f7ff !important;
  font-weight: bold;
  cursor: pointer;
}

.child-row td {
  background-color: #fafafa;
}

.child-row td:first-child {
  padding-left: 24px !important;
}

.toggle-btn {
  min-width: 24px !important;
}


.fixed-modal-content {
  overflow: hidden !important;
  height:fit-content !important;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: auto;
  /* Removed max-height to allow dynamic growth when expanding nested rows */
}
.table-wrapper{
  /* Removed max-height to allow table to grow dynamically with expanded content */
  overflow-y: visible;
}
.table-wrapper-ungrouped{
    height: 100%;
    position: relative;
}

.v-dialog--scrollable > .v-card > .v-card__text, .v-dialog--scrollable > form > .v-card > .v-card__text {
    overflow-y: auto !important;
    height: auto !important;

}

.gp-1{
  display: flex ;
  gap:1%;
  justify-content: center;
}

/* Set a minimum width for the first column to accommodate expanded content */
.v-data-table ::v-deep td:first-child {
  max-width: 250px;
}


/* Style for the toggle button to maintain position */
.toggle-btn {
  min-width: 24px;
  width: 24px;
}


.commentary1-textarea ::v-deep .v-input__slot {
  height: 300px;
}
.commentary1-textarea ::v-deep .v-input__slot textarea{
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0 2.5px 0 0 !important;
  padding-top: 14px !important;
}
.commentary1-textarea ::v-deep .v-input__append-inner{
  position: absolute;
  right: 5px;
}
.skeleton-textarea{
  height: 200px;
}
/* .font-size-lg {
  font-size: 1.5rem;
}
.font-size-md {
  font-size: 1.200rem;
} */
.border-left-custom {
  border-left: 4px solid var(--custom-border-color) !important;
}
.custom-view-label ::v-deep .v-label {
    font-size: 1rem;
}

.local-commentary-proforma-margin {
  margin-top: 3%;
}

.local-commentary-forecast-margin {
  margin-top: 3.5%;
}
.role-selector{
  cursor: pointer;
  max-width: min-content;
}
/* Remove border from dropdown */
.role-selector >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  cursor: pointer;
  padding: 0 !important;
}

.role-selector >>> fieldset {
  border: none !important;
  cursor: pointer;
}

.highlight-chip {
  color: #c62828 !important;
}
.highlight-chip .v-icon {
  color: #c62828 !important;
}
.highlight-chip--self {
  font-weight: 600 !important;
  box-shadow:0 0 8px rgba(198, 40, 40, 0.35);
}
::v-deep .v-data-table thead {
  background-color: var(--color-table-header-bg) !important;
}

/* ================================
   RUList ↔ RUDataSection directional slide transitions
   ================================ */

/* Forward: RUList slides out left, RUDataSection slides in from right */
.ru-view-forward-enter-active,
.ru-view-forward-leave-active {
  transition: opacity var(--duration-smooth, 300ms) var(--ease-standard, ease),
              transform var(--duration-smooth, 300ms) var(--ease-standard, ease);
}
.ru-view-forward-enter {
  opacity: 0;
  transform: translateX(30px);
}
.ru-view-forward-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* Back: RUDataSection slides out right, RUList slides in from left */
.ru-view-back-enter-active,
.ru-view-back-leave-active {
  transition: opacity var(--duration-smooth, 300ms) var(--ease-standard, ease),
              transform var(--duration-smooth, 300ms) var(--ease-standard, ease);
}
.ru-view-back-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.ru-view-back-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

</style>
